function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickbookSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2475 1650",
    style: {
      enableBackground: "new 0 0 2475 1650"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 2475,
    height: 1650
  })), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 165.0895,
    y1: 820.9955,
    x2: 2309.9104,
    y2: 820.9955
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M2249.222,893.127c-37.186-40.791-81.161-80.575-92.629-135.957 c-19.844-95.836,65.009-177.553,92.785-271.152c19.207-64.721,9.298-138.41-26.205-194.88 c-35.503-56.47-95.879-94.575-159.674-100.773c-109.765-10.665-217.186,67.663-325.311,44.978 c-86.576-18.163-154.992-98.288-242.877-106.872c-103.417-10.1-189.223,80.307-287.98,114.346 c-118.125,40.714-246.194-1.836-362.33-48.528c-116.136-46.693-238.325-98.788-360.744-76.441 C347.991,142.723,233.74,268.466,215.515,413.623c-18.062,143.856,133.421,259.335,4.473,432.065 c-40.297,53.978-67.1,129.133-49.286,195.306c17.309,64.296,90.964,104.961,91.499,171.816 c0.422,52.778-46.567,94.772-50.353,147.399c-3.249,45.172,27.429,86.933,65.13,108.341 c37.701,21.408,81.444,26.643,123.977,31.496l-0.005,0.006c-2.405,2.738-3.066,6.595-1.71,9.977 c1.356,3.382,4.499,5.707,8.129,6.027c207.992,18.36,417.189,13.961,625.9,9.545c339.139-7.177,678.277-14.353,1017.416-21.529 c34.854-0.737,70.556-1.645,103.032-15.067c32.476-13.422,61.604-42.153,66.55-78.698c8.418-62.194-52.969-116.168-47.295-178.71 c7.244-79.861,113.435-110.671,133.641-187.994C2320.892,988.958,2286.409,933.917,2249.222,893.127z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2177.655,440.995c0.931-5.264,8.541-5.141,9.325,0.147 c3.936,26.548,11.445,60.432,25.501,82.552c26.088,41.051,73.477,190.542-56.638,265.07 c-130.115,74.528-162.11,113.979-161.144,257.099c0.884,130.807-6.99,409.948-8.352,457.01c-0.11,3.798-3.219,6.804-7.019,6.804 l0,0c-3.871,0-7.011-3.123-7.022-6.993c-0.173-61.215-1.035-506.203,10.125-614.029 C2000.116,717.799,2144.19,630.273,2177.655,440.995z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029030484339708161420000003504533033581492635_",
    gradientUnits: "userSpaceOnUse",
    x1: 1987.99,
    y1: 749.0471,
    x2: 2187.3108,
    y2: 749.0471
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029030484339708161420000003504533033581492635_)"
    },
    d: "M2180.371,552.086 c3.808,9.37,5.56,18.938,6.497,28.742c0.459,4.887,0.555,9.812,0.317,14.721c-0.226,4.909-0.672,9.821-1.503,14.675 c-3.102,19.473-11.124,38.1-22.472,54.118c-5.641,8.017-12.067,15.567-18.924,22.383c-6.828,6.888-13.978,13.375-21.223,19.668 c-14.5,12.581-29.373,24.42-43.193,37.25c-6.904,6.414-13.629,12.994-19.882,19.978c-6.263,6.974-12.133,14.269-17.64,21.832 c-5.398,7.639-10.348,15.589-14.847,23.803l-3.202,6.252l-1.594,3.132l-1.457,3.2l-2.909,6.404l-2.629,6.531 c-13.857,34.994-19.982,72.79-22.786,110.565l-0.001,0.012c-0.101,1.36-1.286,2.381-2.646,2.28 c-1.33-0.099-2.335-1.238-2.285-2.56c0.746-19.133,2.56-38.265,5.787-57.222c0.699-4.757,1.814-9.445,2.702-14.174 c0.957-4.717,2.189-9.38,3.31-14.067c1.31-4.639,2.606-9.289,4.054-13.893c1.581-4.563,2.955-9.199,4.783-13.681l2.609-6.77 l2.901-6.657l1.456-3.327l1.598-3.264l3.217-6.519c4.528-8.577,9.539-16.902,15.024-24.915 c11.098-15.946,24.286-30.334,38.388-43.442c14.059-13.188,28.976-25.192,43.196-37.672c7.11-6.242,14.049-12.612,20.605-19.298 c6.589-6.689,12.665-13.617,18.014-21.179c10.755-15.007,18.486-32.109,22.09-50.192c1.814-9.037,2.452-18.302,2.167-27.545 c-0.305-9.187-1.698-18.626-4.378-27.198l-0.064-0.205c-0.431-1.379,0.337-2.846,1.716-3.277 C2178.473,550.166,2179.862,550.844,2180.371,552.086z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2270.109,811.056c2.355-5.178,9.946-4.525,11.424,0.968 c13.397,49.816,41.051,198.511-81.187,268.885c-148.121,85.274-151.696,46.705-170.166,196.846 c-15.897,129.225-21.321,207.808-22.524,227.195c-0.165,2.662-2.37,4.725-5.038,4.725l0,0c-2.856,0-5.143-2.352-5.045-5.206 c1.397-40.686,11.575-309.554,40.654-441.064C2089.949,829.493,2211.06,940.867,2270.109,811.056z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102527993992286264850000000377566552719230619_",
    gradientUnits: "userSpaceOnUse",
    x1: 2030.665,
    y1: 1003.0664,
    x2: 2269.9854,
    y2: 1003.0664
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000102527993992286264850000000377566552719230619_)"
    },
    d: "M2269.984,838.432 c-0.193,4.645-0.84,9.088-1.968,13.484c-1.049,4.403-2.447,8.712-4.058,12.949c-0.719,2.158-1.77,4.166-2.644,6.263 c-0.878,2.099-1.964,4.088-3.06,6.074c-2.049,4.063-4.589,7.824-7.052,11.648c-10.377,14.946-23.914,27.516-38.826,37.735 c-7.383,5.239-15.455,9.475-23.262,13.806l-11.608,6.151c-3.827,2.121-7.564,4.393-11.351,6.58 c-14.978,9.021-29.235,19.158-42.527,30.438c-13.137,11.46-25.045,24.237-35.703,38.01l-7.631,10.607 c-1.336,1.728-2.381,3.646-3.542,5.49l-3.417,5.575l-3.422,5.577l-3.009,5.812c-1.967,3.895-4.071,7.728-5.932,11.678 l-5.134,12.068c-0.809,2.03-1.82,3.984-2.466,6.078l-2.13,6.212c-1.372,4.157-2.957,8.25-4.248,12.438l-3.49,12.691 l-1.748,6.352l-1.336,6.453l-2.653,12.925c-0.496,2.147-0.797,4.327-1.09,6.508l-0.957,6.536l-1.928,13.086l-0.014,0.092 c-0.126,0.856-0.922,1.447-1.778,1.321c-0.83-0.122-1.411-0.879-1.33-1.704l1.318-13.27l0.666-6.642 c0.219-2.215,0.448-4.43,0.872-6.616l2.228-13.177l1.128-6.592l1.547-6.51l3.101-13.032c1.172-4.308,2.604-8.549,3.945-12.815 l2.047-6.391c0.618-2.154,1.605-4.176,2.391-6.272l5.005-12.474c1.824-4.091,3.897-8.074,5.837-12.119l2.973-6.04l3.397-5.815 l3.401-5.817c1.157-1.925,2.199-3.925,3.534-5.736l7.647-11.111c10.721-14.448,23.003-27.709,36.414-39.695 c13.552-11.833,28.286-22.196,43.584-31.51c3.869-2.251,7.695-4.588,11.603-6.767l11.838-6.314 c7.686-4.223,15.374-8.118,22.493-13.083c14.383-9.547,27.556-21.019,38.065-34.712c5.26-6.84,9.75-14.24,13.589-21.997 c3.731-7.763,6.638-16.141,8.022-24.559l0.023-0.14c0.119-0.726,0.804-1.218,1.53-1.098 C2269.541,837.173,2270.012,837.769,2269.984,838.432z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2032.125,1500.146c-2.841,1.369-6.233-0.128-7.109-3.158 c-8.72-30.135-42.528-170.87,68.151-225.459c98.057-48.363,181.533-27.967,212.388-17.209c5.512,1.922,6.93,9.086,2.531,12.924 c-11.668,10.178-29.714,29.964-34.029,57.735c-6.507,41.876-65.03,63.998-120.838,37.643 c-55.285-26.108-153.972-10.145-118.372,131.655C2035.438,1496.635,2034.315,1499.09,2032.125,1500.146L2032.125,1500.146z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103234925124728970000000005958592900366333885_",
    gradientUnits: "userSpaceOnUse",
    x1: 2028.8684,
    y1: 1308.9355,
    x2: 2253.8333,
    y2: 1308.9355
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103234925124728970000000005958592900366333885_)"
    },
    d: "M2252.136,1264.977 c-21.426-1.924-43.039-1.84-64.284,0.206c-21.23,2.119-42.294,6.19-62.144,13.698c-4.992,1.797-9.818,3.975-14.668,6.108 l-7.097,3.563c-2.388,1.151-4.604,2.605-6.918,3.891c-9.081,5.406-17.892,11.394-25.748,18.536l-3.029,2.586l-2.844,2.787 c-1.878,1.876-3.837,3.682-5.659,5.619c-3.472,4.024-7.212,7.85-10.358,12.172c-6.747,8.308-12.277,17.527-17.709,26.848 l-0.04,0.068c-0.414,0.71-1.324,0.95-2.034,0.536c-0.664-0.387-0.914-1.216-0.604-1.902c4.531-9.944,9.44-19.867,15.865-28.861 c2.949-4.684,6.557-8.885,9.986-13.238c1.791-2.111,3.726-4.096,5.587-6.153l2.823-3.061l3.029-2.855 c7.97-7.742,16.905-14.483,26.335-20.37c9.424-5.917,19.447-10.877,29.827-14.829c10.372-3.971,21.032-7.172,31.869-9.476 c10.855-2.199,21.833-3.728,32.854-4.337c5.504-0.37,11.02-0.501,16.527-0.415c5.506,0.029,11.006,0.291,16.487,0.719 c10.966,0.909,21.834,2.426,32.534,5.24c0.796,0.209,1.271,1.024,1.062,1.82c-0.188,0.714-0.862,1.17-1.574,1.105 L2252.136,1264.977z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1742.903,91.512c0.267-6.081,8.33-7.973,11.323-2.673 c14.447,25.586,46.962,69.229,112.03,100.817c97.601,47.383,272.761,145.38,168.31,359.469 c-108.59,222.571-70.043,378.038-77.526,455.871c-6.929,72.078-14.226,443.465-15.267,497.992 c-0.071,3.723-3.109,6.687-6.833,6.687l0,0c-3.842,0-6.929-3.164-6.833-7.005c1.514-60.144,12.257-488.947,12.454-557.598 c0.211-73.86,18.479-326.6-47.535-418.771C1829.162,437.133,1732.743,322.727,1742.903,91.512z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000164493765481565359170000015190467417761446297_",
    gradientUnits: "userSpaceOnUse",
    x1: 1780.1405,
    y1: 387.015,
    x2: 2011.4021,
    y2: 387.015
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000164493765481565359170000015190467417761446297_)"
    },
    d: "M1782.053,155.711 c7.78,8.543,15.96,16.773,24.147,24.929c4.092,4.084,8.316,8.037,12.446,12.073c4.24,3.929,8.388,7.945,12.715,11.772 l6.389,5.843l6.497,5.721c4.287,3.862,8.766,7.502,13.129,11.271c4.344,3.792,8.891,7.341,13.324,11.022 c4.456,3.654,9.087,7.087,13.582,10.687c4.535,3.549,9.193,6.936,13.782,10.412c4.625,3.427,9.38,6.672,14.062,10.017 c9.534,6.66,19.107,13.701,28.069,21.381c17.976,15.303,34.165,33.291,45.958,54.08c5.902,10.36,10.841,21.282,14.57,32.584 c3.721,11.302,6.437,22.9,8.151,34.61c3.415,23.453,3.066,47.145,0.756,70.447c-2.318,23.329-6.896,46.309-12.799,68.856 c-5.89,22.557-12.94,44.76-20.996,66.568c-0.208,0.564-0.834,0.852-1.398,0.643c-0.543-0.201-0.828-0.796-0.662-1.343 c6.788-22.176,13.075-44.488,18.043-67.071c2.536-11.279,4.58-22.649,6.473-34.022c0.981-5.682,1.633-11.408,2.467-17.106 c0.599-5.723,1.277-11.441,1.711-17.171c1.734-22.904,1.51-45.979-2.302-68.436c-1.949-11.203-4.561-22.271-8.263-32.969 c-3.673-10.705-8.478-20.982-14.177-30.716c-11.419-19.489-26.671-36.585-44.087-51.236 c-8.691-7.403-17.892-14.057-27.368-20.711c-4.733-3.441-9.538-6.784-14.208-10.306c-4.633-3.57-9.334-7.053-13.908-10.695 c-9.118-7.324-18.034-14.887-26.744-22.673c-4.338-3.912-8.65-7.853-12.838-11.923l-6.319-6.062l-6.195-6.188 c-8.172-8.335-16.196-16.809-23.811-25.649c-7.67-8.791-15.055-17.804-21.901-27.289c-0.352-0.488-0.242-1.168,0.245-1.52 c0.454-0.327,1.074-0.255,1.442,0.149L1782.053,155.711z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169555528509163776860000016273800897456027582_",
    gradientUnits: "userSpaceOnUse",
    x1: 2455.24,
    y1: 756.7624,
    x2: 1525.4171,
    y2: 1977.4531,
    gradientTransform: "matrix(0.9999 -0.0105 0.0105 0.9999 -22.683 -37.8145)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000169555528509163776860000016273800897456027582_)"
    },
    d: "M2100.36,737.883l30.004,1.564 c14.84,0.774,26.457,13.064,26.394,27.924l-3.016,711.894c-0.069,16.211-13.323,29.267-29.533,29.09l-206.007-2.242 L2100.36,737.883z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1740.65,742.243l380.039-22.363c7.861-0.463,14.445,5.88,14.276,13.754l-15.778,733.703 c-0.337,15.658-13.371,28.041-29.026,27.576l-267.365-7.945L1740.65,742.243z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052797105538543315840000001736150911351174054_",
    gradientUnits: "userSpaceOnUse",
    x1: 1761.1093,
    y1: 1102.8473,
    x2: 2111.2034,
    y2: 1102.8473
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052797105538543315840000001736150911351174054_)"
    },
    d: "M1761.109,757.452l333.976-46.172 c8.586-1.187,16.217,5.54,16.117,14.207l-8.518,739.936c-0.12,10.433-8.393,18.942-18.819,19.356l-245.959,9.772 L1761.109,757.452z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181081759607010806660000004351920347897665978_",
    gradientUnits: "userSpaceOnUse",
    x1: 2126.7073,
    y1: 955.8114,
    x2: 1421.849,
    y2: 1560.597,
    gradientTransform: "matrix(0.9999 -0.0105 0.0105 0.9999 -22.683 -37.8145)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181081759607010806660000004351920347897665978_)"
    },
    d: "M1672.828,721.599l366.408-26.663 c18.261-1.329,33.858,13.023,34.05,31.331l7.91,755.425c0.16,15.319-12.128,27.868-27.448,28.028l-338.041,3.539 c-15.95,0.167-29.245-12.17-30.269-28.088l-46.623-724.554C1637.52,740.48,1652.702,723.063,1672.828,721.599z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150095768628446526950000000517313228827232187_",
    gradientUnits: "userSpaceOnUse",
    x1: 2102.6455,
    y1: 926.5687,
    x2: 1368.2372,
    y2: 1556.7091,
    gradientTransform: "matrix(0.9999 -0.0105 0.0105 0.9999 -22.683 -37.8145)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150095768628446526950000000517313228827232187_)"
    },
    d: "M2096.898,991.869l-41.657,0.436 c-4.236,0.044-7.705-3.353-7.75-7.589l-2.2-210.092c-0.044-4.236,3.354-7.705,7.589-7.75l41.657-0.436 c4.236-0.044,7.705,3.353,7.75,7.589l2.199,210.092C2104.531,988.355,2101.134,991.825,2096.898,991.869z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M465.978,352.926c-1.012-5.725-9.288-5.591-10.14,0.159c-4.28,28.87-12.446,65.716-27.732,89.77 c-28.368,44.64-79.902,207.202,61.59,288.247c141.492,81.045,176.285,123.945,175.234,279.579 c-0.961,142.244,7.602,445.793,9.082,496.97c0.119,4.13,3.501,7.399,7.632,7.399l0,0c4.209,0,7.625-3.396,7.636-7.605 c0.188-66.568,1.125-550.464-11.011-667.718C659.041,653.932,502.369,558.754,465.978,352.926z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE5FE"
    },
    d: "M468.094,475.788c-2.964,9.356-4.494,19.627-4.853,29.644 c-0.338,10.075,0.352,20.178,2.313,30.035c3.896,19.724,12.317,38.389,24.038,54.752c5.829,8.243,12.453,15.804,19.629,23.083 c7.142,7.28,14.696,14.212,22.434,21.002c15.476,13.576,31.695,26.622,46.973,40.947c15.326,14.237,29.644,29.862,41.706,47.169 c5.961,8.697,11.407,17.734,16.33,27.045l3.498,7.078l1.737,3.543l1.583,3.613l3.155,7.228l2.839,7.351 c1.988,4.867,3.483,9.902,5.204,14.858c1.576,5,2.987,10.051,4.414,15.09c1.219,5.091,2.565,10.156,3.609,15.28l1.542,7.69 c0.534,2.559,1.027,5.125,1.409,7.709c3.526,20.597,5.516,41.389,6.357,62.186c0.055,1.363-1.005,2.513-2.368,2.568 c-1.335,0.054-2.465-0.962-2.563-2.284l-0.001-0.016c-2.998-41.095-9.617-82.233-24.684-120.341l-2.859-7.112l-3.163-6.976 l-1.584-3.485l-1.733-3.411l-3.483-6.811c-4.893-8.948-10.279-17.609-16.153-25.932c-5.99-8.241-12.382-16.187-19.2-23.783 c-6.807-7.607-14.127-14.772-21.64-21.754c-15.039-13.967-31.213-26.849-46.969-40.525c-7.873-6.84-15.639-13.89-23.052-21.371 c-7.445-7.406-14.418-15.589-20.539-24.287c-12.315-17.375-21.026-37.564-24.421-58.678c-0.908-5.264-1.398-10.591-1.65-15.915 c-0.265-5.326-0.168-10.667,0.317-15.971c0.991-10.634,2.88-21.033,6.972-31.187c0.54-1.34,2.064-1.989,3.404-1.449 c1.275,0.514,1.924,1.918,1.519,3.207L468.094,475.788z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M767.251,1515.135c11.606,6.252-106.238-154.17-135.661-400.166 c-13.864-115.92-8.577-260.29-72.083-318.434c-52.853-48.392-239.855-26.275-301.102-17.495 c-7.653,1.097-10.58,10.6-4.853,15.795c28.229,25.612,88.412,85.779,102.44,144.631 c18.49,77.572,89.591,129.183,154.411,144.895c64.82,15.712,100.669,29.925,128.495,135.613 C666.725,1325.662,734.274,1497.37,767.251,1515.135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE5FE"
    },
    d: "M342.705,814.752c9.887,0.609,19.563,2.026,29.22,3.859c9.646,1.824,19.216,4.09,28.673,6.797 c9.459,2.703,18.765,5.959,27.936,9.58c9.188,3.586,18.152,7.774,26.885,12.415c17.534,9.158,33.964,20.589,48.72,33.955 c14.646,13.47,27.606,28.963,37.687,46.222l3.746,6.488c1.234,2.171,2.264,4.449,3.405,6.67 c1.079,2.237,2.258,4.489,3.253,6.713l2.997,6.676c4.016,8.892,7.989,17.803,11.87,26.755 c7.78,17.895,15.268,35.92,22.462,54.061c14.415,36.278,27.626,73.016,38.506,110.594c0.318,1.1-0.315,2.249-1.414,2.567 c-1.052,0.305-2.15-0.262-2.521-1.275l-0.023-0.064c-6.638-18.215-13.573-36.411-20.876-54.417 c-7.199-18.054-14.599-36.027-22.183-53.921l-11.449-26.808l-11.737-26.684c-3.899-8.9-7.89-17.76-11.923-26.601l-3.01-6.637 c-1.001-2.216-2.099-4.272-3.142-6.416c-1.071-2.115-2.029-4.291-3.189-6.358l-3.518-6.182 c-9.423-16.493-21.761-31.163-35.471-44.332c-7.005-6.434-14.253-12.659-22.07-18.154l-2.89-2.114l-2.974-2 c-1.989-1.324-3.944-2.701-5.962-3.985c-4.072-2.511-8.115-5.077-12.325-7.371c-16.681-9.448-34.442-17.054-52.701-23.235 c-18.246-6.17-37.182-10.799-56.236-13.479l-0.078-0.011c-0.91-0.128-1.544-0.969-1.416-1.879 C341.077,815.317,341.849,814.701,342.705,814.752z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M671.048,1514.923c6.22,3.601-33.037-70.594-33.735-134.616 c-0.698-64.023-10.785-173.648-63.296-241.069c-52.511-67.421-112.614-75.767-190.998-19.48 c-65.32,46.906-105.831,70.278-129.193,73.995c-5.785,0.92-8.971,7.283-6.382,12.537c13.78,27.967,53.314,92.518,124.06,90.891 c90.241-2.075,201.656-56.263,232.969-6.128s25.96,77.28,26.063,100.455C630.639,1414.683,629.888,1491.09,671.048,1514.923z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE5FE"
    },
    d: "M405.486,1199.14c10.307-9.093,21.561-16.872,33.485-23.704 c11.919-6.8,24.606-12.501,38.057-16.249c6.727-1.846,13.642-3.208,20.694-3.837c7.051-0.575,14.236-0.412,21.335,0.752 c1.764,0.357,3.55,0.597,5.295,1.06c1.728,0.479,3.527,0.887,5.196,1.438l9.845,3.493l9.607,4.186l9.281,4.927 c12.148,7.032,23.013,16.339,31.922,27.124c8.977,10.764,15.864,22.991,21.414,35.593l2.079,4.736 c0.708,1.573,1.2,3.225,1.81,4.832c1.139,3.242,2.378,6.451,3.428,9.714c1.931,6.577,3.999,13.109,5.388,19.799 c3.266,13.267,5.169,26.768,6.826,40.235c0.11,0.894-0.526,1.708-1.42,1.818c-0.849,0.105-1.625-0.463-1.796-1.285l-0.011-0.054 c-2.708-13.208-5.403-26.398-9.246-39.236c-1.726-6.478-4.019-12.755-6.14-19.076c-1.15-3.126-2.478-6.178-3.705-9.267 c-1.173-3.116-2.648-6.086-4.076-9.073c-5.657-11.966-12.634-23.244-21.126-33.17c-8.492-9.931-18.693-18.229-29.957-24.741 l-8.66-4.528l-9.01-3.858l-9.289-3.229c-1.541-0.504-3.044-0.854-4.566-1.295c-1.518-0.422-3.093-0.634-4.637-0.967 c-6.239-1.076-12.666-1.287-19.086-0.816c-6.428,0.417-12.864,1.498-19.213,3.07c-12.718,3.127-25.09,8.071-37.047,13.921 c-11.921,5.903-23.561,12.717-34.532,20.313l-0.059,0.041c-0.77,0.533-1.826,0.341-2.359-0.429 C404.719,1200.662,404.849,1199.701,405.486,1199.14z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000071522055067955590180000001881357507625850549_",
    gradientUnits: "userSpaceOnUse",
    x1: 2120.5789,
    y1: 533.6267,
    x2: 935.7003,
    y2: 2089.1599,
    gradientTransform: "matrix(0.9999 -0.0105 0.0105 0.9999 -22.683 -37.8145)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000071522055067955590180000001881357507625850549_)"
    },
    d: "M1670.154,530.57l38.234,1.993 c18.911,0.986,33.714,16.648,33.634,35.583l-3.843,907.17c-0.087,20.658-16.978,37.295-37.635,37.07l-262.516-2.858 L1670.154,530.57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1211.774,536.126l484.286-28.497c10.018-0.59,18.408,7.493,18.192,17.526l-20.105,934.962 c-0.429,19.954-17.038,35.733-36.988,35.14l-340.704-10.124L1211.774,536.126z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041272561658796769650000012052370431193704378_",
    gradientUnits: "userSpaceOnUse",
    x1: 1237.8444,
    y1: 995.6461,
    x2: 1683.9713,
    y2: 995.6461
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000041272561658796769650000012052370431193704378_)"
    },
    d: "M1237.844,555.507l425.588-58.838 c10.941-1.513,20.665,7.059,20.538,18.103l-10.855,942.905c-0.153,13.295-10.695,24.138-23.98,24.666l-313.428,12.453 L1237.844,555.507z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023962351599298839280000004295911037180462498_",
    gradientUnits: "userSpaceOnUse",
    x1: 1726.3944,
    y1: 969.2878,
    x2: 742.0112,
    y2: 1239.6892,
    gradientTransform: "matrix(0.9999 -0.0105 0.0105 0.9999 -22.683 -37.8145)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023962351599298839280000004295911037180462498_)"
    },
    d: "M1125.348,509.819l466.916-33.977 c23.27-1.693,43.146,16.595,43.39,39.926l10.079,962.643c0.204,19.521-15.455,35.512-34.976,35.716l-430.768,4.51 c-20.325,0.213-37.267-15.508-38.572-35.792l-59.411-923.304C1080.354,533.88,1099.7,511.685,1125.348,509.819z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021833734476687946130000016663365739999426486_",
    gradientUnits: "userSpaceOnUse",
    x1: 1669.2001,
    y1: 761.5258,
    x2: 691.3051,
    y2: 1030.1449,
    gradientTransform: "matrix(0.9999 -0.0105 0.0105 0.9999 -22.683 -37.8145)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021833734476687946130000016663365739999426486_)"
    },
    d: "M1654.254,854.346l-30.108,0.315 c-11.742,0.123-21.361-9.296-21.483-21.038l-2.563-244.745c-0.123-11.742,9.296-21.361,21.038-21.484l30.108-0.315 c11.742-0.123,21.361,9.296,21.484,21.038l2.562,244.745C1675.416,844.605,1665.996,854.224,1654.254,854.346z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024000698012496121730000013797354746233382328_",
    gradientUnits: "userSpaceOnUse",
    x1: 949.7961,
    y1: 1066.6201,
    x2: 881.2719,
    y2: 662.0001
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000024000698012496121730000013797354746233382328_)"
    },
    d: "M579.871,377.077l704.681-6.35 c38.877-0.35,71.208,29.827,73.535,68.636l61.223,1021.188c1.82,30.369-21.866,56.212-52.278,57.039l-807.521,21.958 c-28.577,0.777-52.233-22.038-52.49-50.624l-9.267-1028.235C497.341,414.924,534.106,377.491,579.871,377.077z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M676.796,1524.075c-0.003,0-0.005,0-0.008,0l-90.383-0.355 c-30.355-0.119-55.273-24.911-55.547-55.266l-1.229-136.445c-0.011-1.201,0.955-2.184,2.156-2.195 c1.096-0.003,2.184,0.954,2.195,2.156l1.229,136.445c0.253,27.986,23.226,50.844,51.213,50.953l90.383,0.355 c1.201,0.004,2.171,0.983,2.167,2.184C678.967,1523.106,677.993,1524.075,676.796,1524.075z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M532.002,1289.188c-1.193,0-2.165-0.961-2.175-2.156l-0.199-22.096 c-0.011-1.201,0.955-2.184,2.156-2.195c0.006,0,0.013,0,0.019,0c1.193,0,2.165,0.961,2.176,2.156l0.199,22.096 c0.011,1.201-0.955,2.184-2.156,2.195C532.015,1289.188,532.009,1289.188,532.002,1289.188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M581.963,368.777c96.349,12.183,427.624,49.562,701.029,26.094 c12.468-1.07,23.381,8.285,24.158,20.776l63.789,1025.719c0.875,14.064-9.762,26.193-23.82,27.153 c-115.007,7.847-588.658,38.441-757.847,22.26c-10.297-0.984-18.183-9.575-18.337-19.919L554.88,393.03 C554.661,378.389,567.437,366.94,581.963,368.777z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M592.511,395.304c92.72,11.724,411.521,47.695,674.631,25.111 c11.999-1.03,22.501,7.973,23.249,19.993l61.386,987.095c0.842,13.534-9.394,25.207-22.923,26.13 c-110.676,7.551-566.492,36.993-729.309,21.422c-9.909-0.948-17.5-9.215-17.648-19.169L566.447,418.643 C566.236,404.554,578.53,393.536,592.511,395.304z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1267.81,1357.027c2.2-0.02,3.865-1.831,3.7-4.025l-0.467-6.219 c-0.165-2.194-2.1-3.987-4.3-3.984l-603.965,0.682c-2.2,0.003-2.866,1.402-1.48,3.111l10.284,12.679 c1.386,1.709,4.32,3.09,6.52,3.071L1267.81,1357.027z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M663.134,1382.951c-2.2,0.002-2.866,1.402-1.48,3.111l10.284,12.679 c1.386,1.709,4.32,3.09,6.52,3.071l589.708-5.314c2.2-0.02,3.865-1.831,3.7-4.025l-0.467-6.22 c-0.165-2.194-2.1-3.987-4.3-3.984L663.134,1382.951z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1208.613,532.341c2.2-0.02,3.936-1.835,3.857-4.034l-0.222-6.207 c-0.078-2.199-1.943-4.016-4.142-4.04l-238.991-2.514c-2.2-0.023-3.434,1.667-2.742,3.755l3.77,11.379 c0.692,2.088,3.058,3.781,5.258,3.761L1208.613,532.341z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M969.471,555.017c-2.2-0.023-3.434,1.667-2.742,3.755l3.77,11.38 c0.692,2.088,3.058,3.781,5.258,3.761l233.211-2.101c2.2-0.02,3.936-1.835,3.857-4.034l-0.221-6.208 c-0.078-2.199-1.943-4.016-4.142-4.04L969.471,555.017z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157986699201618485460000017888078064148373682_",
    gradientUnits: "userSpaceOnUse",
    x1: 596.9238,
    y1: 3127.6736,
    x2: 272.7936,
    y2: 3554.0593,
    gradientTransform: "matrix(1 -0.009 0.009 1 427.2634 -2993.9841)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000157986699201618485460000017888078064148373682_)"
    },
    d: "M974.661,234.211 c-25.613-17.478-47.743-16.928-63.282-12.19c-14.175,4.322-23.262,18.126-21.777,32.871l7.379,73.279l80.018,6.375 C976.999,334.546,1024.894,268.489,974.661,234.211z M940.034,293.695c-11.011,0.099-20.017-8.746-20.116-19.757 c-0.099-11.011,8.746-20.017,19.757-20.116c11.01-0.099,20.017,8.746,20.116,19.757 C959.889,284.589,951.044,293.595,940.034,293.695z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M903.347,299.05c-1.395-0.497-2.456-1.762-2.613-3.336l-1.174-11.671 c-0.219-2.175,1.366-4.116,3.542-4.335c2.174-0.223,4.12,1.361,4.338,3.544l1.174,11.671c0.219,2.175-1.367,4.116-3.542,4.334 C904.469,299.318,903.883,299.241,903.347,299.05z M901.045,276.181c-1.395-0.497-2.456-1.761-2.613-3.336l-0.893-8.861 c-1.511-15.009,7.817-29.078,22.18-33.459c9.831-2.998,19.992-3.509,30.194-1.514c2.112,0.448,3.548,2.498,3.125,4.648 c-0.419,2.145-2.499,3.548-4.646,3.128c-8.913-1.745-17.783-1.299-26.362,1.316c-10.758,3.279-17.744,13.83-16.61,25.092 l0.893,8.862c0.218,2.176-1.367,4.115-3.542,4.334C902.167,276.449,901.581,276.372,901.045,276.181z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104696611592384226580000015809692038540216716_",
    gradientUnits: "userSpaceOnUse",
    x1: 632.4799,
    y1: 3154.6992,
    x2: 308.3477,
    y2: 3581.0874,
    gradientTransform: "matrix(1 -0.009 0.009 1 427.2634 -2993.9841)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000104696611592384226580000015809692038540216716_)"
    },
    d: "M788.284,376.549l-0.332-36.873 c-0.116-12.728,10.343-23.018,23.067-22.696l254.299,6.419c11.286,0.285,20.503,9.108,21.28,20.37l2.444,35.41L788.284,376.549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M871.717,330.574c-1.193,0-2.165-0.961-2.176-2.155c-0.011-1.203,0.954-2.185,2.155-2.196 l10.933-0.099c1.24-0.109,2.184,0.955,2.196,2.156c0.011,1.201-0.954,2.184-2.155,2.195l-10.933,0.099 C871.73,330.574,871.724,330.574,871.717,330.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M800.594,366.649c-1.52-0.542-2.615-1.986-2.63-3.696l-0.135-14.917 c-0.056-6.125,2.276-11.903,6.569-16.274c4.292-4.37,10.03-6.81,16.156-6.866l40.194-0.361c2.176-0.013,3.976,1.736,3.994,3.927 c0.02,2.187-1.737,3.975-3.925,3.997l-40.194,0.36c-8.276,0.075-14.951,6.869-14.875,15.147l0.134,14.917 c0.02,2.187-1.738,3.975-3.925,3.997C801.481,366.882,801.021,366.801,800.594,366.649z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005237268698582102640000009926393950266209934_",
    gradientUnits: "userSpaceOnUse",
    x1: 591.6349,
    y1: 3180.7793,
    x2: 367.8273,
    y2: 3591.7356,
    gradientTransform: "matrix(1 -0.009 0.009 1 427.2634 -2993.9841)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005237268698582102640000009926393950266209934_)"
    },
    d: "M708.507,363.772l444.551-4.018 c15.985-0.145,29.754,11.235,32.623,26.962l0.396,2.17c3.142,17.225-9.998,33.124-27.507,33.282l-456.084,4.11 c-10.479,0.095-18.907-8.591-18.499-19.061l0.797-20.422C685.283,374.02,695.723,363.888,708.507,363.772z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089549116163098311740000014933975927586880388_",
    gradientUnits: "userSpaceOnUse",
    x1: 673.6121,
    y1: 554.2191,
    x2: 619.2251,
    y2: 900.1212
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000089549116163098311740000014933975927586880388_)"
    },
    d: "M669.846,513.396h-27.133v-19.188 h77.654v19.188h-27.583v81.851h-22.937V513.396z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110452854951737921440000010649204813848253606_",
    gradientUnits: "userSpaceOnUse",
    x1: 764.6648,
    y1: 568.5355,
    x2: 710.2778,
    y2: 914.4376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000110452854951737921440000010649204813848253606_)"
    },
    d: "M745.249,569.312l-7.196,25.935 h-23.686l30.882-101.039h29.982l31.331,101.039h-24.586l-7.795-25.935H745.249z M770.883,552.222l-6.296-21.438 c-1.799-5.996-3.598-13.492-5.097-19.488h-0.3c-1.5,5.996-2.999,13.641-4.647,19.488l-5.996,21.438H770.883z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089551569503185512300000014413171723079668156_",
    gradientUnits: "userSpaceOnUse",
    x1: 847.2486,
    y1: 581.5204,
    x2: 792.8616,
    y2: 927.4222
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000089551569503185512300000014413171723079668156_)"
    },
    d: "M869.674,595.247l-9.145-18.289 c-3.748-7.046-6.146-12.293-8.994-18.139h-0.301c-2.098,5.846-4.647,11.093-7.795,18.139l-8.395,18.289H808.96l29.232-51.12 l-28.183-49.919h26.234l8.844,18.439c2.999,6.146,5.246,11.093,7.645,16.79h0.301c2.398-6.446,4.347-10.943,6.895-16.79 l8.546-18.439h26.084l-28.482,49.32l29.982,51.719H869.674z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#FFFFFF"
    },
    d: "M1280.05,1240.776l-31.806-542.152c-0.923-15.771-14.375-28.125-30.624-28.125 c-0.292,0-0.586,0.004-0.877,0.012l-572.611,15.446c-16.822,0.456-30.197,14.133-29.816,30.491l11.036,474.636l-0.72,0.023 l0.276,8.698l0.646-0.02l1.335,57.422c0.178,7.906,3.665,15.549,9.551,20.953c5.717,5.3,13.212,8.218,21.104,8.218l0.776-0.01 l442.701-10.512l-0.266,0.394l8.392-0.567v-0.034l76.296-1.805l0.302,2.406l8.755-0.567l-0.098-2.045l55.743-1.323 c8.234-0.201,16.179-3.69,21.783-9.572C1277.566,1256.825,1280.532,1248.818,1280.05,1240.776z M1246.493,817.363l-81.632,4.023 l-3.736-57.13l82.019-3.992L1246.493,817.363z M1067.561,768.795l3.592,57.186L726.26,842.969v-57.577L1067.561,768.795z  M1071.869,834.666l3.845,61.051L726.26,912.765v-61.083L1071.869,834.666z M1076.43,904.401l3.829,60.81L726.26,982.467v-60.99 L1076.43,904.401z M1080.975,973.895l3.837,60.924l-358.551,17.477v-61.117L1080.975,973.895z M1089.963,973.471l75.882-3.7 l3.985,60.924l-75.882,3.701L1089.963,973.471z M1170.398,1039.379l3.981,60.865l-75.885,3.653l-3.978-60.818L1170.398,1039.379z  M1179.09,1038.955l80.173-3.91l3.575,60.94l-79.767,3.84L1179.09,1038.955z M1178.522,1030.271l-3.985-60.924l80.641-3.933 l3.576,60.945L1178.522,1030.271z M1173.969,960.662l-3.977-60.813l81.107-3.959l3.569,60.836L1173.969,960.662z  M1165.277,961.086l-75.882,3.701l-3.977-60.81l75.882-3.704L1165.277,961.086z M1084.85,895.292l-3.993-61.055l75.88-3.739 l3.996,61.091L1084.85,895.292z M1080.289,825.552l-3.74-57.18l75.883-3.693l3.737,57.135L1080.289,825.552z M624.443,790.362 l93.116-4.546v57.582l-91.925,4.537L624.443,790.362z M717.558,852.11v61.08l-90.157,4.415l-1.566-60.967L717.558,852.11z  M717.558,921.902v60.989l-88.539,4.333l-1.564-60.917L717.558,921.902z M717.558,991.603v61.117l-86.916,4.253l-1.568-61.047 L717.558,991.603z M630.844,1065.675l86.714-4.243v60.774l-85.452,4.121L630.844,1065.675z M726.26,1061.008l359.268-17.504 l3.829,60.812l-363.096,17.471V1061.008z M1090.073,1112.999l3.988,63.23l-367.8,11.64v-57.371L1090.073,1112.999z  M1099.062,1112.581l75.885-3.653l4.227,64.621l-75.967,2.405L1099.062,1112.581z M1183.639,1108.51l79.709-3.837l3.877,66.089 l-79.35,2.512L1183.639,1108.51z M1250.59,887.203l-81.166,3.962l-3.996-61.095l81.574-4.02L1250.59,887.203z M632.457,1135.028 l85.101-4.111v57.228l-83.953,2.662L632.457,1135.028z M657.812,1277.667l-0.416,0.008c-5.691,0-11.012-2.095-15.13-5.911 c-4.164-3.824-6.588-9.202-6.714-14.757l-1.614-57.498l83.621-2.656v79.39L657.812,1277.667z M726.26,1276.034v-79.458 l368.516-11.658l5.231,82.245L726.26,1276.034z M1109.158,1266.957l-5.384-82.314l75.967-2.405l5.423,82.913L1109.158,1266.957z  M1265.638,1256.737c-4.026,4.225-9.743,6.732-15.684,6.876l-56.083,1.331l-5.427-82.982l79.292-2.51l3.628,61.839 C1271.701,1246.935,1269.614,1252.565,1265.638,1256.737z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054266512056688609710000003117018366817857721_",
    gradientUnits: "userSpaceOnUse",
    x1: -2664.8079,
    y1: 6626.0308,
    x2: -3014.967,
    y2: 7085.9546,
    gradientTransform: "matrix(0.0317 -0.9995 0.9995 0.0317 -4900.0068 -2148.0813)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054266512056688609710000003117018366817857721_)"
    },
    d: "M1648.66,1003.026 c-14.339-0.454-25.594-12.446-25.14-26.785l6.99-220.79c0.385-12.181,10.249-21.922,22.434-22.157l320.62-6.163 c9.535-0.183,17.327,7.565,17.199,17.1l-3.412,253.198c-0.121,8.96-7.568,16.078-16.525,15.795L1648.66,1003.026z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065052819276479011240000016913199986556059781_",
    gradientUnits: "userSpaceOnUse",
    x1: 1802.1508,
    y1: 987.6559,
    x2: 1791.5067,
    y2: 669.7589
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065052819276479011240000016913199986556059781_)"
    },
    d: "M1628.197,984.272 c-4.588-0.119-8.011-4.265-7.251-8.792c5.044-30.021,20.972-133.302,17.105-219.232c-0.176-3.919,2.893-7.217,6.815-7.302 l322.071-6.909c4.416-0.095,8.08,3.391,8.201,7.807c0.992,36.12,4.539,184.859-2.685,237.643 c-0.439,3.212-3.23,5.573-6.472,5.49L1628.197,984.272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M1636.367,980.975c-4.416-0.114-7.71-4.104-6.978-8.461 c4.853-28.891,20.182-128.282,16.461-210.977c-0.17-3.771,2.784-6.946,6.558-7.027l309.943-6.649 c4.25-0.091,7.775,3.264,7.892,7.513c0.955,34.76,4.369,177.898-2.583,228.695c-0.423,3.091-3.109,5.364-6.229,5.283 L1636.367,980.975z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023977310560652665840000014841707596343124131_",
    gradientUnits: "userSpaceOnUse",
    x1: 2690.1272,
    y1: -52.1887,
    x2: 2623.8518,
    y2: 76.3853,
    gradientTransform: "matrix(0.9995 0.0317 -0.0317 0.9995 -966.9349 636.3196)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023977310560652665840000014841707596343124131_)"
    },
    d: "M1683.784,769.275l-2.942-0.093 c-3.2-0.102-5.711-2.777-5.61-5.977l1.362-43.024c0.074-2.335,1.542-4.398,3.725-5.231l6.258-2.39 c4.034-1.54,8.275,1.712,7.833,6.008l-4.678,45.507C1689.422,767.1,1686.824,769.371,1683.784,769.275z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029030555700375232150000003566796512523242652_",
    gradientUnits: "userSpaceOnUse",
    x1: 2750.5378,
    y1: -55.4151,
    x2: 2684.2629,
    y2: 73.158,
    gradientTransform: "matrix(0.9995 0.0317 -0.0317 0.9995 -966.9349 636.3196)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029030555700375232150000003566796512523242652_)"
    },
    d: "M1744.267,767.964l-2.942-0.093 c-3.199-0.101-5.711-2.777-5.61-5.977l1.363-43.024c0.074-2.336,1.542-4.398,3.725-5.232l6.258-2.39 c4.033-1.541,8.275,1.712,7.833,6.007l-4.679,45.508C1749.905,765.79,1747.307,768.061,1744.267,767.964z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004521757996483025600000006359329175849006260_",
    gradientUnits: "userSpaceOnUse",
    x1: 2831.0862,
    y1: -55.4201,
    x2: 2764.811,
    y2: 73.1536,
    gradientTransform: "matrix(0.9995 0.0317 -0.0317 0.9995 -966.9349 636.3196)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000004521757996483025600000006359329175849006260_)"
    },
    d: "M1824.775,770.513l-2.941-0.093 c-3.199-0.102-5.711-2.777-5.61-5.977l1.362-43.025c0.073-2.335,1.542-4.398,3.725-5.231l6.258-2.39 c4.034-1.541,8.275,1.712,7.834,6.008l-4.679,45.508C1830.413,768.339,1827.816,770.609,1824.775,770.513z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000943929743172620680000006017416271245057451_",
    gradientUnits: "userSpaceOnUse",
    x1: 2911.634,
    y1: -59.7807,
    x2: 2845.3589,
    y2: 68.7932,
    gradientTransform: "matrix(0.9995 0.0317 -0.0317 0.9995 -966.9349 636.3196)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000943929743172620680000006017416271245057451_)"
    },
    d: "M1905.421,768.708l-2.942-0.093 c-3.199-0.102-5.711-2.777-5.61-5.977l1.362-43.025c0.074-2.335,1.543-4.398,3.726-5.231l6.258-2.39 c4.034-1.541,8.275,1.712,7.833,6.008l-4.679,45.507C1911.059,766.534,1908.461,768.804,1905.421,768.708z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.72,
      fill: "#FFFFFF"
    },
    d: "M1828.62,808.864l-0.706,22.309c-0.108,3.405,2.594,6.239,6,6.294l22.887,0.368 c3.332,0.054,6.091-2.576,6.197-5.908l0.742-23.455c0.112-3.525-2.78-6.411-6.305-6.291l-22.923,0.776 C1831.299,803.067,1828.722,805.65,1828.62,808.864z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.72,
      fill: "#FFFFFF"
    },
    d: "M1748.302,836.385l22.887,0.368c3.332,0.053,6.091-2.577,6.196-5.908l0.632-19.948 c0.111-3.505-2.748-6.382-6.254-6.293l-22.917,0.584c-3.233,0.082-5.841,2.673-5.943,5.906l-0.601,18.997 C1742.193,833.497,1744.895,836.331,1748.302,836.385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.72,
      fill: "#FFFFFF"
    },
    d: "M1767.317,935.991l-21.77-0.439c-3.647-0.073-6.674,2.801-6.789,6.447 l-0.645,20.384c-0.115,3.621,2.686,6.669,6.304,6.86l21.747,1.148c3.727,0.197,6.888-2.708,7.006-6.439l0.668-21.094 C1773.956,939.153,1771.024,936.065,1767.317,935.991z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.72,
      fill: "#FFFFFF"
    },
    d: "M1730.415,961.812l0.631-19.93c0.115-3.642-2.767-6.677-6.41-6.75l-21.998-0.443 c-3.584-0.072-6.559,2.753-6.673,6.336l-0.608,19.214c-0.113,3.559,2.641,6.554,6.196,6.743l21.976,1.16 C1727.192,968.334,1730.299,965.478,1730.415,961.812z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.72,
      fill: "#FFFFFF"
    },
    d: "M1733.264,871.833l0.518-16.361c0.125-3.951-3.026-7.231-6.978-7.266l-21.009-0.181 c-3.827-0.033-6.979,2.995-7.1,6.82l-0.495,15.636c-0.122,3.856,2.881,7.093,6.735,7.259l20.986,0.906 C1729.838,878.815,1733.14,875.752,1733.264,871.833z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.72,
      fill: "#FFFFFF"
    },
    d: "M1731.759,919.378l0.792-25.024c0.114-3.583-2.677-6.591-6.259-6.745l-21.478-0.927 c-3.918-0.169-7.219,2.894-7.343,6.813l-0.799,25.238c-0.116,3.666,2.804,6.712,6.472,6.751l22.005,0.232 C1728.708,925.753,1731.645,922.937,1731.759,919.378z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.72,
      fill: "#FFFFFF"
    },
    d: "M1791.103,837.074l22.886,0.368c3.332,0.054,6.091-2.577,6.197-5.908l0.687-21.729 c0.111-3.504-2.748-6.382-6.253-6.292l-22.917,0.583c-3.233,0.083-5.841,2.674-5.943,5.907l-0.658,20.777 C1784.995,834.186,1787.697,837.019,1791.103,837.074z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.72,
      fill: "#FFFFFF"
    },
    d: "M1774.571,919.718l0.741-23.405c0.115-3.646-2.724-6.706-6.368-6.863l-21.754-0.939 c-3.704-0.16-6.825,2.736-6.943,6.442l-0.763,24.115c-0.118,3.73,2.853,6.83,6.584,6.869l21.777,0.23 C1771.468,926.204,1774.456,923.339,1774.571,919.718z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.72,
      fill: "#FFFFFF"
    },
    d: "M1814.465,848.964l-24.994-0.216c-2.744-0.024-5.005,2.148-5.092,4.89 l-0.712,22.505c-0.087,2.766,2.066,5.086,4.83,5.206l24.968,1.078c2.809,0.122,5.177-2.075,5.265-4.885l0.74-23.368 C1819.559,851.34,1817.3,848.988,1814.465,848.964z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.72,
      fill: "#FFFFFF"
    },
    d: "M1827.151,855.275l-0.679,21.433c-0.11,3.476,2.597,6.393,6.07,6.543l22.376,0.966 c3.531,0.153,6.506-2.608,6.618-6.14l0.703-22.207c0.113-3.561-2.727-6.518-6.289-6.548l-22.4-0.193 C1830.101,849.099,1827.26,851.828,1827.151,855.275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.72,
      fill: "#FFFFFF"
    },
    d: "M1745.731,879.502l24.968,1.078c2.809,0.121,5.177-2.075,5.266-4.885l0.693-21.891 c0.09-2.833-2.169-5.185-5.004-5.21l-24.996-0.216c-2.744-0.023-5.005,2.148-5.091,4.89l-0.666,21.028 C1740.814,877.062,1742.967,879.383,1745.731,879.502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.72,
      fill: "#FFFFFF"
    },
    d: "M1811.709,891.297l-21.753-0.939c-3.704-0.16-6.825,2.736-6.943,6.441 l-0.719,22.719c-0.118,3.73,2.853,6.83,6.585,6.869l21.777,0.23c3.623,0.038,6.611-2.826,6.725-6.448l0.697-22.01 C1818.192,894.514,1815.353,891.454,1811.709,891.297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.72,
      fill: "#FFFFFF"
    },
    d: "M1855.227,893.177l-23.277-1.005c-3.28-0.142-6.044,2.423-6.147,5.705 l-0.724,22.873c-0.105,3.304,2.527,6.047,5.831,6.082l23.301,0.246c3.207,0.034,5.854-2.503,5.956-5.71l0.7-22.113 C1860.968,896.026,1858.454,893.315,1855.227,893.177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.72,
      fill: "#FFFFFF"
    },
    d: "M1708.703,835.452l17.371,0.279c4.62,0.074,8.446-3.572,8.592-8.19l0.454-14.329 c0.137-4.329-3.395-7.883-7.725-7.773l-19.34,0.492c-4.388,0.112-7.926,3.629-8.065,8.016l-0.379,11.966 C1699.446,831.074,1703.541,835.37,1708.703,835.452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.72,
      fill: "#FFFFFF"
    },
    d: "M1688.234,941.523c0.124-3.919-2.977-7.185-6.897-7.264l-7.567-0.152 c-5.751-0.116-10.493,3.636-10.644,8.423l-0.439,13.851c-0.15,4.748,4.273,8.773,9.969,9.073l8.121,0.429 c3.663,0.194,6.771-2.661,6.887-6.328L1688.234,941.523z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.72,
      fill: "#FFFFFF"
    },
    d: "M1931.619,939.3L1916.738,939c-3.65-0.073-6.68,2.803-6.795,6.452l-0.822,25.953 c-0.115,3.624,2.689,6.675,6.31,6.866l14.808,0.781c5.904,0.312,10.901-3.487,11.056-8.408l0.705-22.257 C1942.154,943.508,1937.483,939.418,1931.619,939.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.72,
      fill: "#FFFFFF"
    },
    d: "M1674.464,925.18l7.387,0.078c3.831,0.04,6.992-2.99,7.113-6.819l0.805-25.44 c0.122-3.856-2.881-7.093-6.735-7.259l-7.432-0.321c-5.86-0.253-10.781,3.533-10.935,8.414l-0.705,22.256 C1663.806,921.01,1668.552,925.118,1674.464,925.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.72,
      fill: "#FFFFFF"
    },
    d: "M1675.594,876.473l9.296,0.402c2.963,0.128,5.46-2.189,5.553-5.153l0.582-18.374 c0.095-2.988-2.288-5.469-5.277-5.495l-9.391-0.081c-5.695-0.05-10.349,3.685-10.499,8.425l-0.355,11.197 C1665.353,872.18,1669.848,876.225,1675.594,876.473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.72,
      fill: "#FFFFFF"
    },
    d: "M1935.449,800.14l-14.93,0.38c-3.364,0.085-6.076,2.781-6.182,6.144l-0.812,25.636 c-0.112,3.542,2.698,6.49,6.242,6.547l15.366,0.247c5.731,0.092,10.442-3.654,10.593-8.424l0.679-21.444 C1946.566,804.158,1941.535,799.985,1935.449,800.14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.72,
      fill: "#FFFFFF"
    },
    d: "M1810.113,936.852l-21.77-0.439c-3.647-0.073-6.674,2.801-6.789,6.447 l-0.689,21.779c-0.115,3.621,2.686,6.669,6.304,6.86l21.747,1.148c3.727,0.197,6.888-2.708,7.006-6.438l0.712-22.489 C1816.752,940.015,1813.82,936.927,1810.113,936.852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.72,
      fill: "#FFFFFF"
    },
    d: "M1934.3,849.998l-15.127-0.13c-3.448-0.03-6.29,2.699-6.399,6.146l-0.772,24.388 c-0.11,3.475,2.596,6.392,6.07,6.542l15.183,0.656c5.86,0.253,10.781-3.533,10.935-8.414l0.636-20.097 C1944.983,854.161,1940.222,850.049,1934.3,849.998z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.72,
      fill: "#FFFFFF"
    },
    d: "M1933.263,896.546l-15.783-0.681c-3.28-0.141-6.044,2.423-6.148,5.704 l-0.636,20.083c-0.105,3.303,2.526,6.047,5.831,6.082l15.864,0.167c5.704,0.061,10.373-3.677,10.523-8.424l0.439-13.851 C1943.505,900.839,1939.01,896.794,1933.263,896.546z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.72,
      fill: "#FFFFFF"
    },
    d: "M1868.567,899.722l-0.68,21.477c-0.104,3.304,2.526,6.048,5.831,6.083l23.301,0.246 c3.208,0.034,5.854-2.503,5.956-5.71l0.656-20.718c0.102-3.229-2.412-5.938-5.639-6.078l-23.277-1.005 C1871.435,893.876,1868.671,896.441,1868.567,899.722z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.72,
      fill: "#FFFFFF"
    },
    d: "M1895.7,938.576l-21.758-0.438c-3.65-0.073-6.68,2.803-6.795,6.452l-0.777,24.559 c-0.115,3.624,2.689,6.674,6.309,6.865l21.737,1.147c3.73,0.198,6.894-2.71,7.012-6.444l0.8-25.268 C1902.344,941.742,1899.41,938.651,1895.7,938.576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.72,
      fill: "#FFFFFF"
    },
    d: "M1677.251,834.946l9.106,0.146c2.909,0.047,5.318-2.249,5.409-5.157l0.569-17.971 c0.097-3.059-2.399-5.571-5.459-5.493l-9.649,0.246c-5.524,0.14-9.924,3.821-10.069,8.421l-0.339,10.719 C1666.663,830.754,1671.366,834.852,1677.251,834.946z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.72,
      fill: "#FFFFFF"
    },
    d: "M1852.904,937.714l-21.393-0.431c-3.853-0.078-7.051,2.959-7.172,6.811 l-0.722,22.797c-0.115,3.624,2.689,6.675,6.31,6.866l21.735,1.147c3.731,0.197,6.894-2.711,7.012-6.444l0.756-23.872 C1859.548,940.879,1856.614,937.789,1852.904,937.714z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.72,
      fill: "#FFFFFF"
    },
    d: "M1871.479,807.756l-0.755,23.856c-0.112,3.542,2.698,6.49,6.242,6.547l22.395,0.36 c3.466,0.056,6.337-2.68,6.446-6.145l0.785-24.788c0.116-3.646-2.859-6.639-6.506-6.546l-22.424,0.571 C1874.297,801.698,1871.585,804.393,1871.479,807.756z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.72,
      fill: "#FFFFFF"
    },
    d: "M1869.963,855.644l-0.725,22.911c-0.11,3.475,2.597,6.392,6.07,6.542l22.376,0.967 c3.531,0.152,6.506-2.608,6.618-6.141l0.75-23.684c0.113-3.561-2.726-6.517-6.289-6.548l-22.401-0.194 C1872.913,849.468,1870.072,852.198,1869.963,855.644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1675.264,787.364l0.952,7.567c0.305,2.423,2.326,4.265,4.768,4.342l0.357,0.011 c2.74,0.086,5.032-2.064,5.119-4.804l0.245-7.733c0.095-2.997-2.469-5.393-5.453-5.097l-1.554,0.155 C1676.919,782.081,1674.915,784.593,1675.264,787.364z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1710.357,785.784l0.952,7.567c0.305,2.423,2.327,4.265,4.768,4.342l0.357,0.011 c2.74,0.087,5.032-2.064,5.118-4.804l0.245-7.733c0.095-2.997-2.469-5.393-5.453-5.096l-1.554,0.155 C1712.012,780.502,1710.008,783.015,1710.357,785.784z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1753.503,786.829l0.953,7.567c0.304,2.423,2.327,4.264,4.767,4.342l0.357,0.011 c2.74,0.087,5.032-2.064,5.119-4.804l0.245-7.734c0.095-2.997-2.469-5.393-5.453-5.096l-1.554,0.155 C1755.158,781.546,1753.155,784.059,1753.503,786.829z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1795.566,785.385l0.952,7.567c0.305,2.423,2.327,4.264,4.768,4.342l0.357,0.011 c2.74,0.087,5.032-2.064,5.118-4.804l0.245-7.733c0.095-2.997-2.469-5.393-5.453-5.096l-1.554,0.155 C1797.222,780.102,1795.218,782.615,1795.566,785.385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1838.806,780.345l0.952,7.567c0.305,2.423,2.327,4.264,4.768,4.342l0.357,0.011 c2.74,0.087,5.032-2.065,5.118-4.804l0.245-7.733c0.095-2.998-2.468-5.394-5.453-5.097l-1.554,0.155 C1840.462,775.062,1838.458,777.575,1838.806,780.345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1884.542,781.792l0.952,7.568c0.305,2.423,2.327,4.264,4.768,4.341l0.357,0.011 c2.74,0.087,5.032-2.064,5.119-4.804l0.245-7.733c0.095-2.997-2.469-5.393-5.453-5.097l-1.554,0.155 C1886.197,776.51,1884.193,779.023,1884.542,781.792z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1923.163,781.387l0.953,7.567c0.305,2.423,2.327,4.264,4.768,4.341l0.357,0.011 c2.74,0.087,5.032-2.064,5.118-4.804l0.245-7.733c0.095-2.997-2.469-5.393-5.453-5.096l-1.554,0.155 C1924.818,776.105,1922.814,778.617,1923.163,781.387z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025430885989746257570000015454071151762356613_",
    gradientUnits: "userSpaceOnUse",
    x1: 6817.9443,
    y1: -1482.0118,
    x2: 6514.7935,
    y2: -1356.5214,
    gradientTransform: "matrix(0.9995 0.0317 -0.0317 0.9995 -966.9349 636.3196)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000025430885989746257570000015454071151762356613_)"
    },
    d: "M1860.095,869.853 c-0.077-1.634-1.776-2.352-3.043-1.375c-3.578,2.758-5.066,7.085-6.857,11.116c-2.087,4.698-4.09,9.433-5.876,14.254 c-1.883,5.082-3.496,10.26-4.739,15.521c-2.289-6.323-4.962-12.487-8.373-18.345c-0.905-1.555-3.518-0.678-3.021,1.163 c2.891,10.703,6.476,21.196,9.191,31.951c0.958,3.795,6.143,2.955,6.567-0.678c1.156-9.922,3.654-19.399,7.157-28.745 c1.666-4.443,3.518-8.814,5.437-13.153C1858.235,877.718,1860.3,874.141,1860.095,869.853z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045577367698811411590000002914809864954488489_",
    gradientUnits: "userSpaceOnUse",
    x1: 6822.5303,
    y1: -1471.4388,
    x2: 6519.3662,
    y2: -1345.943,
    gradientTransform: "matrix(0.9995 0.0317 -0.0317 0.9995 -966.9349 636.3196)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000045577367698811411590000002914809864954488489_)"
    },
    d: "M1864.888,877.819 c-3.081-0.61-4.246,3.33-1.427,4.605c18.647,8.437,20.854,31.687,7.174,45.609c-6.327,6.439-14.685,11.4-22.594,15.658 c-8.022,4.318-16.961,7.587-26.207,6.561c-21.432-2.379-24.121-24.246-17.53-41.029c6.339-16.142,19.682-28.516,35.922-34.344 c2.098-0.753,1.324-4.163-0.826-3.417c-15.235,5.284-28.265,15.886-36.415,29.853c-7.496,12.847-12.103,31.03-2.602,44.105 c9.831,13.529,28.755,13.966,43.074,8.519c15.75-5.992,35.4-17.209,41.817-33.717 C1891.996,902.927,1884.143,881.63,1864.888,877.819z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031895253822857326220000000669899185470632871_",
    gradientUnits: "userSpaceOnUse",
    x1: 6791.875,
    y1: -1545.6353,
    x2: 6488.7075,
    y2: -1420.1379,
    gradientTransform: "matrix(0.9995 0.0317 -0.0317 0.9995 -966.9349 636.3196)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031895253822857326220000000669899185470632871_)"
    },
    d: "M1807.73,874.279 c-0.02-5.039,0.263-10.387-1.707-15.093c-0.656-1.566-2.801-0.969-3.316,0.327c-1.675,4.215-1.345,8.994-1.425,13.475 c-0.039,2.144,0.117,4.557,0.172,6.974c-2.328-7.439-5.858-16.473-13.488-19.825c-7.818-3.435-16.692-0.515-24.052,2.733 c-17.288,7.63-30.604,21.673-46.787,31.125c-9.733,5.685-23.615,9.969-29.588-2.996c-4.227-9.174-1.975-21.591,1.314-30.727 c6.336-17.602,20.318-31.641,37.377-39.048c1.238-0.538,0.439-2.672-0.858-2.231c-16.943,5.763-30.383,18.378-38.026,34.524 c-6.343,13.402-12.406,37.047,1.429,47.981c15.08,11.917,35.9-4.71,47.966-13.664c8.538-6.336,16.927-12.997,26.454-17.82 c5.357-2.711,11.809-5.642,17.962-5.18c8.517,0.639,11.579,10.05,13.542,17.027c0.984,3.499,5.653,3.09,6.761,0.56 c-0.03,1.267-0.129,2.503-0.325,3.681c-6.502-0.346-12.844-5.906-19.417-3.744c-0.934,0.307-1.257,1.575-0.349,2.147 c5.769,3.636,15.353,8.818,22.331,8.127c1.523-0.15,2.774-0.816,3.289-2.343C1808.583,885.554,1807.75,879.215,1807.73,874.279z "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000064354221573643631370000004624302899610906273_",
    gradientUnits: "userSpaceOnUse",
    x1: -2927.3848,
    y1: 995.0012,
    x2: -2897.5466,
    y2: 1080.2532,
    gradientTransform: "matrix(-1 0 0 1 -2359.3977 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000064354221573643631370000004624302899610906273_)"
    },
    d: "M554.742,1040.731 c0.459,1.46-4.858,3.682-7.989-2.288c-0.11-2.861-1.85-15.12-0.14-17.451c9.106-12.415,26.761-27.977,26.761-27.977 c2.984,2.944,0.526,5.836,0.526,5.836l-8.565,8.922c1.792,3.237,3.977,5.97,5.001,9.886c0.776,2.965,0.301,6.134-1.197,8.833 c-1.503,2.708-3.555,6.229-5.494,8.985C559.975,1040.692,554.742,1040.731,554.742,1040.731z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136411244386230805530000007046722844434110353_",
    gradientUnits: "userSpaceOnUse",
    x1: 552.2676,
    y1: 1040.6686,
    x2: 529.5606,
    y2: 1126.5291
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000136411244386230805530000007046722844434110353_)"
    },
    d: "M561.589,1013.563l-7.805,6.616 l-2.45,6.587l6.959,7.72c0,0,2.339-13.071,4.079-15.9C564.11,1015.758,563.208,1014.39,561.589,1013.563z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045585382491050545530000013477591196465784709_",
    gradientUnits: "userSpaceOnUse",
    x1: 6560.2959,
    y1: 1512.5599,
    x2: 6369.9033,
    y2: 1719.6538,
    gradientTransform: "matrix(1 0 0 1 -6098.6797 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000045585382491050545530000013477591196465784709_)"
    },
    d: "M401.433,1527.987 c0,0-1.972,11.162-2.938,22.212c-0.378,4.318,2.951,8.068,7.283,8.248c14.715,0.613,46.19,1.804,57.485,1.3 c1.698-0.076,2.808-1.814,2.18-3.393l0,0c-0.527-1.323-1.542-2.393-2.836-2.988l-51.992-23.895L401.433,1527.987z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072963917266887919740000015570487158333183913_",
    gradientUnits: "userSpaceOnUse",
    x1: 6498.4971,
    y1: 1527.941,
    x2: 6515.4087,
    y2: 1527.941,
    gradientTransform: "matrix(1 0 0 1 -6098.6797 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072963917266887919740000015570487158333183913_)"
    },
    d: "M399.817,1521.428l1.584,13.352 c0,0,9.108,4.24,15.327-0.534l-3.772-14.879L399.817,1521.428z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072246125936421228750000004314922933284574858_",
    gradientUnits: "userSpaceOnUse",
    x1: 6575.2871,
    y1: 1278.3588,
    x2: 6413.2813,
    y2: 1497.9369,
    gradientTransform: "matrix(1 0 0 1 -6098.6797 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072246125936421228750000004314922933284574858_)"
    },
    d: "M401.008,1270.412 c-0.684,3.487-3.673,173.996,14.553,250.407c0.297,1.247-0.335,2.532-1.521,3.017c-2.795,1.142-8.276,2.796-14.844,3.017 c-2.034,0.068-3.858-1.254-4.431-3.206c-5.21-17.729-30.175-106.553-33.432-191.405c-3.639-94.814,0-3.228,0-3.228l2.134-58.608 L401.008,1270.412z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000030471731071988301470000007727624704830785186_",
    gradientUnits: "userSpaceOnUse",
    x1: 6517.5835,
    y1: 1473.2935,
    x2: 6327.1924,
    y2: 1680.386,
    gradientTransform: "matrix(1 0 0 1 -6098.6797 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000030471731071988301470000007727624704830785186_)"
    },
    d: "M341.625,1533.811 c0,0-3.139,5.635-6.177,20.609c-0.548,2.704,1.341,5.292,4.087,5.562c4.859,0.478,12.339,1.092,18.33,1.051 c2.762-0.019,4.918-2.424,4.585-5.166c-0.664-5.466-2.731-14.433-9.119-21.422L341.625,1533.811z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000050642454442072438290000015092633470951446412_",
    gradientUnits: "userSpaceOnUse",
    x1: 6437.5479,
    y1: 1527.0739,
    x2: 6452.1494,
    y2: 1527.0739,
    gradientTransform: "matrix(1 0 0 1 -6098.6797 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000050642454442072438290000015092633470951446412_)"
    },
    d: "M338.868,1516.637l3.702,20.191 c0,0,3.66,2.723,10.9,0.749l-1.767-21.725L338.868,1516.637z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000012430241897409157130000009482972741707470984_",
    gradientUnits: "userSpaceOnUse",
    x1: 6546.4141,
    y1: 1257.0558,
    x2: 6384.4082,
    y2: 1476.6339,
    gradientTransform: "matrix(1 0 0 1 -6098.6797 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000012430241897409157130000009482972741707470984_)"
    },
    d: "M328.868,1275.644 c-14.907,89.962,3.233,222.349,9.351,248.26c0.374,1.586,1.655,2.802,3.263,3.068c2.731,0.453,7.227,0.822,11.659-0.465 c1.527-0.443,2.6-1.821,2.662-3.41c0.821-20.948-0.657-149.552,13.233-200.376c0.704-2.576,2.277-4.822,4.453-6.369 l26.959-19.165l2.067-30.979L328.868,1275.644z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136381019746906062590000002033911174367452058_",
    gradientUnits: "userSpaceOnUse",
    x1: 6109.8188,
    y1: 2511.0654,
    x2: 6016.1528,
    y2: 2836.7671,
    gradientTransform: "matrix(1 0 0 1 -6098.6797 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000136381019746906062590000002033911174367452058_)"
    },
    d: "M423.853,1105.183 c-44.672-0.738-93.962,11.729-93.962,11.729c-13.316,77.698-2.329,167.316-2.329,167.316 c34.584,9.069,73.597-5.545,73.597-5.545c5.748-32.476,32.567-123.873,32.567-123.873c21.827-2.709,39.807-9.006,54.614-17.332 c-11.294-13.092-16.619-29.751-18.931-39.598C453.614,1102.789,437.632,1105.411,423.853,1105.183z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137849047769952953550000016898953955755595924_",
    gradientUnits: "userSpaceOnUse",
    x1: -2901.8816,
    y1: 986.075,
    x2: -2872.0435,
    y2: 1071.3275,
    gradientTransform: "matrix(-1 0 0 1 -2359.3977 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137849047769952953550000016898953955755595924_)"
    },
    d: "M555.807,1039.383 c-4.388-5.3-9.942-2.793-9.942-2.793c-6.574,27.769-41.043,50.284-76.456,61.29c2.313,9.848,7.637,26.506,18.931,39.598 C547.11,1104.435,555.807,1039.383,555.807,1039.383z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090274912200924421930000013435360413148989625_",
    gradientUnits: "userSpaceOnUse",
    x1: 6033.5557,
    y1: 2489.1345,
    x2: 5939.8892,
    y2: 2814.8372,
    gradientTransform: "matrix(1 0 0 1 -6098.6797 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090274912200924421930000013435360413148989625_)"
    },
    d: "M347.025,1160.168l-17.134-43.256 c0,0-41.726,28.351-48.589,64.298c7.884,0.581,22.231,2.631,36.274,9.722C320.661,1173.958,347.025,1160.168,347.025,1160.168z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000154414457455353718650000017784925289003389876_",
    gradientUnits: "userSpaceOnUse",
    x1: 385.378,
    y1: 1068.5283,
    x2: 387.5068,
    y2: 1151.5502
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000154414457455353718650000017784925289003389876_)"
    },
    d: "M378.604,1068.916l-14.214,41.106 c-0.235,0.681,0.045,1.435,0.675,1.784c3.875,2.142,17.834,8.334,34.656-2.332c1.752-1.111,2.945-2.923,3.211-4.981 l4.603-35.577H378.604z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104672733421898004910000016875113096007005568_",
    gradientUnits: "userSpaceOnUse",
    x1: 431.6004,
    y1: 1024.1292,
    x2: 389.7344,
    y2: 1066.7048
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000104672733421898004910000016875113096007005568_)"
    },
    d: "M409.531,1030.851 c0,0,15.608,29.381,13.608,41.25c-2.001,11.868-21.345,11.016-38.237,1.377l-11.804-31.725L409.531,1030.851z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089556736070591990980000014125116908342150021_",
    gradientUnits: "userSpaceOnUse",
    x1: -1064.2247,
    y1: 2376.4514,
    x2: -1050.712,
    y2: 2453.5242,
    gradientTransform: "matrix(0.746 -0.6659 0.6659 0.746 -443.4395 -1476.3188)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000089556736070591990980000014125116908342150021_)"
    },
    d: "M385.649,1057.898 c0.686-0.304,0.94-1.144,0.529-1.772c-1.251-1.91-3.595-5.808-4.343-9.22c0,0-2.806-1.797,7.142-4.178 c9.947-2.381,24.782-6.077,27.9-14.544c3.04-8.255-4.947-29.016-17.691-12.474c-0.485,0.629-1.435,0.643-1.918,0.013 c-2.089-2.719-7.582-8.363-15.207-4.941c-7.136,3.202-7.939,8.43-7.841,11.066c0.029,0.775-0.664,1.378-1.427,1.232 c-3.608-0.688-12.265-1.279-16.306,7.602c-3.328,7.316-1.165,11.457,0.805,13.482c0.639,0.656,0.359,1.737-0.517,2.005 c-2.371,0.726-5.433,2.736-5.126,8.292c0.424,7.68,9.01,7.003,11.455,6.653c0.401-0.057,0.804,0.08,1.076,0.38 c2.096,2.32,11.54,12.169,21.762,13.356c0.885,0.103,1.571-0.771,1.281-1.614l-4.424-12.859 c-0.205-0.597,0.081-1.252,0.658-1.508L385.649,1057.898z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176008282118844488760000002091857259023939221_",
    gradientUnits: "userSpaceOnUse",
    x1: 425.6462,
    y1: 1018.2745,
    x2: 383.7805,
    y2: 1060.8499
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176008282118844488760000002091857259023939221_)"
    },
    d: "M387.427,1059.723 c0,0-11.113-7.625-11.925-1.204c-0.812,6.421,10.008,9.301,15.367,6.907L387.427,1059.723z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108301909704347658520000004139401044875608506_",
    gradientUnits: "userSpaceOnUse",
    x1: 328.1105,
    y1: 1410.0775,
    x2: 292.9666,
    y2: 1157.6794
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108301909704347658520000004139401044875608506_)"
    },
    d: "M317.576,1190.932 c0,0-14.584,65.794-1.373,102.784c-16.196,7.509-13.204,6.094-13.204,6.094s-32.04-93.615-21.696-118.599 C301.696,1179.046,311.812,1184.526,317.576,1190.932z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171691314041268850070000003325571545782622886_",
    gradientUnits: "userSpaceOnUse",
    x1: 323.9256,
    y1: 1385.7982,
    x2: 295.8806,
    y2: 1184.3834
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000171691314041268850070000003325571545782622886_)"
    },
    d: "M316.202,1293.716 c0,0,8.346,10.802,7.678,15.104c-0.667,4.302-0.827,6.055-0.827,6.055s-4.194-2.868-3.929-6.533 c0.583,11.632,4.476,24.858,0.936,24.221c-3.54-0.637-21.865-17.528-17.722-35.535 C311.74,1290.495,314.375,1291.205,316.202,1293.716z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135655579497273404440000013010589654413371288_",
    gradientUnits: "userSpaceOnUse",
    x1: 1813.859,
    y1: 1038.301,
    x2: 1703.1627,
    y2: 926.1857
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000135655579497273404440000013010589654413371288_)"
    },
    d: "M1813.264,999.748 c0,0-55.975,71.666,7.888,144.556l24.01-2.237c0,0-46.218-74.212-25.633-133.368l34.01,2.483l18.807-12.259L1813.264,999.748z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034063991979788112680000008608543024441877431_",
    gradientUnits: "userSpaceOnUse",
    x1: 1843.9208,
    y1: 1428.885,
    x2: 1928.6991,
    y2: 1428.885
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034063991979788112680000008608543024441877431_)"
    },
    d: "M1843.921,1350.622 c0,0,45.352,98.844,69.146,139.785c0,0,4.726,25.761,0,33.862l-4.027,1.79l18.796-0.559c0,0,1.67-34.651,0.366-36.587 c-1.304-1.936-3.912-1.809-3.912-1.809s-8.06-63.853-31.401-77.481l-22.621-77.912L1843.921,1350.622z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063602089097994295480000013755949499876805256_",
    gradientUnits: "userSpaceOnUse",
    x1: 1960.4507,
    y1: 1239.2949,
    x2: 1918.4659,
    y2: 1512.1947
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000063602089097994295480000013755949499876805256_)"
    },
    d: "M1901.011,1530.912 c-0.028,0.453,14.678,0.246,22.666,0.1c2.95-0.054,5.464-2.127,6.093-5.01l6.032-31.693c0.573-3.012-1.339-5.938-4.328-6.621 l-3.367-0.769c0,0-4.804,6.59-3.292,12.793c1.512,6.204,2.858,22.274-0.963,24.147c-3.821,1.873-14.813,2.2-14.813,2.2 S1901.263,1526.83,1901.011,1530.912z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096769598435300229570000005572876072275200680_",
    gradientUnits: "userSpaceOnUse",
    x1: 1871.6147,
    y1: 1225.6333,
    x2: 1829.6305,
    y2: 1498.5293
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096769598435300229570000005572876072275200680_)"
    },
    d: "M1800.936,1531.487 c-1.488,0.848-0.874,3.118,0.837,3.101c13.368-0.134,43.323-0.557,45.985-1.664c3.437-1.429-1.252-13.778-6.187-17.957 l-27.247,8.893L1800.936,1531.487z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179638206469745516250000010481730499271660710_",
    gradientUnits: "userSpaceOnUse",
    x1: 1792.4781,
    y1: 1435.1888,
    x2: 1841.5713,
    y2: 1435.1888
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000179638206469745516250000010481730499271660710_)"
    },
    d: "M1792.478,1344.318 c0,0,29.307,141.777,37.597,169.433l-19.612,12.308c0,0,9.828-1.672,17.116-2.2c7.288-0.528,13.992-8.893,13.992-8.893 l-2.349-3.748c0,0-7.349-141.005-5.56-157.016L1792.478,1344.318z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084496621034914676020000003557975505719855542_",
    gradientUnits: "userSpaceOnUse",
    x1: 1686.722,
    y1: 1066.8594,
    x2: 1782.8312,
    y2: 1066.8594
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000084496621034914676020000003557975505719855542_)"
    },
    d: "M1719.728,1013.622 c0,0-4.042,73.752,63.104,111.438l-16.166,36.869c0,0-60.792-36.77-58.544-137.056c0.064-2.878-0.974-5.673-2.853-7.853 l-12.92-14.989c-4.923-5.711-6.762-13.458-4.932-20.772l1.701-6.798c0.569-2.276,3.162-3.371,5.19-2.192l1.351,0.785 c4.301,2.498,7.708,6.285,9.74,10.826l6.344,14.182c2.37,5.297,7.834,8.514,13.616,8.014l3.923-0.339L1719.728,1013.622z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001647458350730504980000016911673025888005274_",
    gradientUnits: "userSpaceOnUse",
    x1: 1792.0411,
    y1: 1119.1062,
    x2: 1972.2255,
    y2: 1475.976
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001647458350730504980000016911673025888005274_)"
    },
    d: "M1780.494,1119.534 c11.233,3.115,49.291,13.127,73.049,12.718l-14.587,82.318l1.161,13.427l-47.561-0.213c0,0-13.389-31.094-23.952-46.596 c-3.051-4.477-0.781-9.817,0.949-14.952l-2.376-1.582c-2.417-1.61-3.466-4.633-2.564-7.394l11.582-35.435 C1776.797,1120.038,1778.678,1119.03,1780.494,1119.534z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131334344625479323520000015141297623953140409_",
    gradientUnits: "userSpaceOnUse",
    x1: 1749.1333,
    y1: 1213.4059,
    x2: 1906.5756,
    y2: 1390.9657
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000131334344625479323520000015141297623953140409_)"
    },
    d: "M1788.745,1220.756l0.936,8.134 c0,0-13.44,40.251,6.72,134.263c0,0,43.664,12.37,79.551-17.23c0,0-10.123-88.733-12.888-92.866 c-13.772-20.587-22.947-25.063-22.947-25.063l-0.414-8.887C1839.703,1219.109,1801.32,1226.049,1788.745,1220.756z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088832667619971411600000003240364136579110037_",
    gradientUnits: "userSpaceOnUse",
    x1: 1807.3608,
    y1: 1114.0444,
    x2: 1837.4031,
    y2: 1114.0444
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088832667619971411600000003240364136579110037_)"
    },
    d: "M1807.363,1126.168 c-0.167-0.22,9.929-30.481,9.929-30.481l14.462,1.312l5.649,34.33C1837.403,1131.328,1814.739,1135.903,1807.363,1126.168z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124851657812683816520000000108632614914829196_",
    gradientUnits: "userSpaceOnUse",
    x1: 1887.949,
    y1: 1091.0769,
    x2: 1813.4418,
    y2: 1069.0796
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124851657812683816520000000108632614914829196_)"
    },
    d: "M1828.292,1047.964 c-0.964,0.601-30.903,12.973-24.47,44.055c0.38,1.837,1.606,3.393,3.319,4.158c4.393,1.959,13.851,5.315,25.164,4.165 c15.684-1.594,25.961-28.962,25.524-36.927C1857.39,1055.451,1837.849,1042.013,1828.292,1047.964z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018956320320882911040000013112992280172038303_",
    gradientUnits: "userSpaceOnUse",
    x1: 1891.0492,
    y1: 1062.0399,
    x2: 1814.0776,
    y2: 1215.9825
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018956320320882911040000013112992280172038303_)"
    },
    d: "M1837.403,1035.881 c-0.787,0.103-17.301,5.855-9.112,17.821c8.189,11.966,11.261,19.011,7.388,24.266c-3.529,4.787-11.346,2.059-10.664,12.019 c0.136,1.994-0.726,3.929-2.38,5.049c-7.367,4.987-25.339,20.335-7.533,42.224c1.447,1.779,1.746,4.235,0.629,6.238 c-5.215,9.354-16.17,36.758,23.491,51.959c39.191,15.021,53.342-10.598,57.295-20.837c0.855-2.215,3.036-3.571,5.407-3.459 c4.306,0.203,10.409-0.513,10.128-6.268c-0.17-3.495-2.352-6.628-4.929-9.14c-2.551-2.486-2.047-6.838,1.05-8.598 c2.339-1.329,4.409-3.404,5.283-6.642c2.375-8.801-2.367-35.116-27.591-39.576c-2.104-0.372-4.307-2.344-4.614-4.459 c-0.005-0.031-0.009-0.063-0.015-0.094c-0.338-2.045,0.354-4.136,2.025-5.362c4.028-2.955,9.193-8.903,4.998-18.442 c-3.721-8.461-10.857-11.315-16.158-12.224c-3.112-0.534-5.159-3.478-4.502-6.566 C1869.387,1045.372,1867.829,1031.891,1837.403,1035.881z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1712.401,499.175c21.73,7.935,74.382,21.747,143.973,3.229c4.697-1.25,9.627,0.927,11.801,5.274 c6.412,12.822,19.225,39.313,25.167,57.729c1.741,5.397-1.514,11.11-7.058,12.306c-27.71,5.976-109.027,18.234-168.205-26.867 c-2.841-2.165-4.822-5.276-5.626-8.756l-8.233-35.663C1703.111,501.618,1707.765,497.482,1712.401,499.175z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112614068979520865510000007715561745074502835_",
    gradientUnits: "userSpaceOnUse",
    x1: 1772.0012,
    y1: 547.434,
    x2: 1794.9785,
    y2: 547.434
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000112614068979520865510000007715561745074502835_)"
    },
    d: "M1792.49,574.987 c-1.021,0-1.976-0.633-2.342-1.648l-18-50.127c-0.464-1.293,0.208-2.717,1.502-3.183c1.294-0.466,2.716,0.208,3.183,1.501 l17.999,50.128c0.464,1.292-0.208,2.717-1.502,3.183C1793.052,574.94,1792.769,574.987,1792.49,574.987z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032629153416327743630000017791324431837894806_",
    gradientUnits: "userSpaceOnUse",
    x1: 1790.001,
    y1: 549.7003,
    x2: 1821.7563,
    y2: 549.7003
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000032629153416327743630000017791324431837894806_)"
    },
    d: "M1819.269,579.867 c-0.923,0-1.811-0.516-2.241-1.404l-26.779-55.358c-0.598-1.237-0.08-2.724,1.156-3.323c1.238-0.594,2.725-0.081,3.324,1.156 l26.778,55.358c0.598,1.237,0.08,2.725-1.156,3.323C1820.003,579.788,1819.634,579.867,1819.269,579.867z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006700931183465752760000005964221513254949794_",
    gradientUnits: "userSpaceOnUse",
    x1: 1808.2615,
    y1: 547.8361,
    x2: 1840.0859,
    y2: 547.8361
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000006700931183465752760000005964221513254949794_)"
    },
    d: "M1837.599,579.423 c-0.94,0-1.841-0.535-2.261-1.445l-26.848-58.199c-0.574-1.247-0.03-2.726,1.217-3.302c1.25-0.576,2.726-0.029,3.302,1.217 l26.848,58.198c0.575,1.248,0.03,2.726-1.217,3.302C1838.302,579.351,1837.947,579.423,1837.599,579.423z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045597827083550625230000006499222259774001046_",
    gradientUnits: "userSpaceOnUse",
    x1: 1829.7141,
    y1: 544.7076,
    x2: 1854.4677,
    y2: 544.7076
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000045597827083550625230000006499222259774001046_)"
    },
    d: "M1851.979,576.24 c-1.036,0-2.003-0.652-2.355-1.687l-19.776-58.087c-0.442-1.301,0.253-2.714,1.554-3.157c1.302-0.441,2.714,0.253,3.157,1.554 l19.776,58.086c0.442,1.301-0.253,2.714-1.553,3.157C1852.515,576.196,1852.245,576.24,1851.979,576.24z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058591570540646575480000017456155535067290543_",
    gradientUnits: "userSpaceOnUse",
    x1: 1846.0417,
    y1: 541.2407,
    x2: 1874.7227,
    y2: 541.2407
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000058591570540646575480000017456155535067290543_)"
    },
    d: "M1872.234,574.987 c-1.003,0-1.95-0.612-2.326-1.607l-23.704-62.516c-0.487-1.285,0.159-2.721,1.444-3.208c1.28-0.486,2.721,0.158,3.208,1.444 l23.704,62.516c0.487,1.285-0.159,2.721-1.444,3.208C1872.826,574.935,1872.528,574.987,1872.234,574.987z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1927.102,517.858l21.36,43.581c1.614,3.294,5.138,5.193,8.779,4.743 c20.846-2.578,90.637-14.311,144.498-59.969c3.57-3.027,4.918-7.939,3.485-12.395l-25.993-80.846 c-1.745-5.429-7.536-8.477-12.98-6.78c-15.661,4.883-46.967,18.509-73.801,54.009c-16.376,21.665-45.199,36.773-60.309,43.629 C1926.803,506.251,1924.523,512.595,1927.102,517.858z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060720030012447669490000004846729582777436844_",
    gradientUnits: "userSpaceOnUse",
    x1: 1973.2889,
    y1: 517.9853,
    x2: 2006.8875,
    y2: 517.9853
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060720030012447669490000004846729582777436844_)"
    },
    d: "M2004.401,548.259 c-0.902,0-1.772-0.492-2.215-1.348l-28.621-55.571c-0.629-1.222-0.148-2.722,1.073-3.352c1.224-0.628,2.721-0.147,3.352,1.072 l28.621,55.571c0.629,1.222,0.148,2.722-1.073,3.352C2005.174,548.17,2004.784,548.259,2004.401,548.259z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001635115872975443570000006687044224615893427_",
    gradientUnits: "userSpaceOnUse",
    x1: 1985.8145,
    y1: 509.9713,
    x2: 2025.9885,
    y2: 509.9713
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001635115872975443570000006687044224615893427_)"
    },
    d: "M2023.502,543.723 c-0.87,0-1.714-0.456-2.171-1.267l-35.197-62.528c-0.674-1.198-0.249-2.715,0.948-3.389c1.201-0.671,2.715-0.249,3.389,0.947 l35.197,62.528c0.674,1.198,0.249,2.715-0.948,3.389C2024.334,543.619,2023.915,543.723,2023.502,543.723z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101063307828362662250000016190524287818021787_",
    gradientUnits: "userSpaceOnUse",
    x1: 2021.3243,
    y1: 514.3486,
    x2: 2041.8098,
    y2: 514.3486
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101063307828362662250000016190524287818021787_)"
    },
    d: "M2039.322,535.19 c-0.971,0-1.891-0.571-2.293-1.521l-15.508-36.708c-0.534-1.266,0.058-2.725,1.324-3.26c1.265-0.528,2.726,0.058,3.261,1.324 l15.508,36.708c0.534,1.266-0.058,2.725-1.324,3.261C2039.973,535.126,2039.645,535.19,2039.322,535.19z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066475889911524345780000017422268916640577981_",
    gradientUnits: "userSpaceOnUse",
    x1: 2026.4216,
    y1: 479.6742,
    x2: 2062.5835,
    y2: 479.6742
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066475889911524345780000017422268916640577981_)"
    },
    d: "M2060.095,522.275 c-0.996,0-1.937-0.604-2.319-1.588l-31.184-80.222c-0.498-1.28,0.137-2.723,1.418-3.221c1.28-0.501,2.721,0.137,3.22,1.418 l31.184,80.222c0.498,1.28-0.137,2.722-1.417,3.22C2060.7,522.22,2060.395,522.275,2060.095,522.275z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000166661515168356324650000007169770393953241741_",
    gradientUnits: "userSpaceOnUse",
    x1: 2044.6665,
    y1: 467.4777,
    x2: 2075.0225,
    y2: 467.4777
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000166661515168356324650000007169770393953241741_)"
    },
    d: "M2072.533,513.759 c-1.079,0-2.072-0.708-2.388-1.796l-25.379-87.586c-0.383-1.319,0.378-2.699,1.697-3.082c1.316-0.38,2.699,0.376,3.082,1.697 l25.379,87.586c0.383,1.319-0.378,2.699-1.697,3.082C2072.996,513.726,2072.762,513.759,2072.533,513.759z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2028.85,502.707c6.031,10.355,18.822,33.691,19.871,47.012c0.18,2.289,1.975,4.101,4.265,4.269 c21.034,1.543,112.818,4.411,153.295-58.358c0.735-1.14,0.913-2.551,0.511-3.847c-3.73-12.028-23.586-74.247-45.35-108.077 c-1.766-2.745-5.753-2.812-7.649-0.156c-15.042,21.071-71.805,96.694-122.311,112.423 C2028.639,496.859,2027.352,500.135,2028.85,502.707z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092442511604571327800000001298975563219365272_",
    gradientUnits: "userSpaceOnUse",
    x1: 2147.1072,
    y1: 455.7988,
    x2: 2189.0649,
    y2: 455.7988
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000092442511604571327800000001298975563219365272_)"
    },
    d: "M2186.573,501.276 c-1.239,0-2.312-0.924-2.466-2.187c-4.111-33.664-36.285-84.435-36.61-84.944c-0.738-1.158-0.398-2.697,0.76-3.436 c1.159-0.735,2.697-0.398,3.435,0.76c1.35,2.116,33.105,52.228,37.353,87.017c0.167,1.363-0.804,2.604-2.169,2.771 C2186.776,501.27,2186.674,501.276,2186.573,501.276z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073703163495092910440000003023619432185939862_",
    gradientUnits: "userSpaceOnUse",
    x1: 2136.0527,
    y1: 466.1835,
    x2: 2174.4346,
    y2: 466.1835
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000073703163495092910440000003023619432185939862_)"
    },
    d: "M2171.944,507.768 c-1.147,0-2.177-0.797-2.43-1.962c-5.26-24.33-32.896-77.031-33.174-77.56c-0.64-1.217-0.172-2.721,1.042-3.36 c1.223-0.642,2.722-0.171,3.36,1.042c1.15,2.187,28.232,53.833,33.636,78.825c0.29,1.343-0.564,2.668-1.906,2.958 C2172.294,507.75,2172.117,507.768,2171.944,507.768z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168837355772361132410000018215955450544155278_",
    gradientUnits: "userSpaceOnUse",
    x1: 2144.0229,
    y1: 503.7996,
    x2: 2160.5615,
    y2: 503.7996
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168837355772361132410000018215955450544155278_)"
    },
    d: "M2158.075,519.251 c-0.953,0-1.861-0.55-2.273-1.476l-11.562-25.926c-0.56-1.255,0.004-2.726,1.258-3.285c1.253-0.56,2.726,0.003,3.285,1.258 l11.562,25.925c0.56,1.255-0.004,2.726-1.259,3.285C2158.757,519.181,2158.413,519.251,2158.075,519.251z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093882071346838314970000007789831253336217498_",
    gradientUnits: "userSpaceOnUse",
    x1: 2132.4382,
    y1: 510.5789,
    x2: 2146.0139,
    y2: 510.5789
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093882071346838314970000007789831253336217498_)"
    },
    d: "M2143.525,524.86 c-1.016,0-1.969-0.627-2.337-1.636l-8.598-23.582c-0.471-1.292,0.194-2.72,1.484-3.19c1.291-0.475,2.719,0.193,3.19,1.484 l8.598,23.582c0.471,1.291-0.195,2.72-1.485,3.19C2144.096,524.81,2143.808,524.86,2143.525,524.86z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1613.228,428.782c17.885,11.335,71.922,43.275,114.509,44.307c1.664,0.04,3.11,1.15,3.618,2.734 l20.149,62.829c0.9,2.806-1.474,5.575-4.382,5.1c-23.65-3.866-107.162-20.218-139.156-62.523 c-0.518-0.685-0.787-1.525-0.787-2.384v-46.728C1607.178,429.008,1610.601,427.117,1613.228,428.782z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091007406145005452940000017974452496605241512_",
    gradientUnits: "userSpaceOnUse",
    x1: 1717.4026,
    y1: 504.984,
    x2: 1737.0685,
    y2: 504.984
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091007406145005452940000017974452496605241512_)"
    },
    d: "M1734.579,533.025 c-1.081,0-2.076-0.711-2.389-1.802L1717.5,480.12c-0.38-1.321,0.383-2.699,1.703-3.078c1.32-0.384,2.699,0.384,3.078,1.703 l14.689,51.104c0.38,1.32-0.383,2.699-1.703,3.078C1735.038,532.994,1734.806,533.025,1734.579,533.025z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136373100040670530330000017140983238303163012_",
    gradientUnits: "userSpaceOnUse",
    x1: 1704.204,
    y1: 502.8569,
    x2: 1720.8772,
    y2: 502.8569
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000136373100040670530330000017140983238303163012_)"
    },
    d: "M1718.386,531.224 c-1.137,0-2.163-0.784-2.425-1.94l-11.696-51.759c-0.303-1.34,0.538-2.671,1.879-2.975c1.339-0.298,2.672,0.537,2.975,1.879 l11.696,51.759c0.302,1.34-0.538,2.671-1.879,2.975C1718.752,531.205,1718.568,531.224,1718.386,531.224z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036237131367818636190000009364038685652936333_",
    gradientUnits: "userSpaceOnUse",
    x1: 1690.1023,
    y1: 486.0297,
    x2: 1700.4442,
    y2: 486.0297
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036237131367818636190000009364038685652936333_)"
    },
    d: "M1697.954,501.021 c-1.119,0.001-2.136-0.76-2.414-1.895c-2.116-8.635-5.635-23.471-5.429-25.821c0.12-1.368,1.308-2.36,2.697-2.259 c1.349,0.119,2.352,1.294,2.264,2.638c0.023,1.745,2.708,13.678,5.3,24.257c0.327,1.335-0.49,2.682-1.823,3.009 C1698.35,500.998,1698.151,501.021,1697.954,501.021z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026846716808626672920000010662985284805693358_",
    gradientUnits: "userSpaceOnUse",
    x1: 1634.5334,
    y1: 471.7139,
    x2: 1640.0701,
    y2: 471.7139
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026846716808626672920000010662985284805693358_)"
    },
    d: "M1637.581,497.101 c-1.341,0-2.448-1.068-2.485-2.417c-1.255-44.518-0.079-46.442,0.365-47.166c0.716-1.172,2.247-1.543,3.42-0.825 c1.065,0.65,1.467,1.973,0.995,3.089c-0.612,2.884-0.359,25.097,0.194,44.761c0.039,1.374-1.043,2.518-2.416,2.557 C1637.628,497.101,1637.604,497.101,1637.581,497.101z M1639.707,450.11c0,0-0.001,0.001-0.002,0.002 C1639.705,450.111,1639.705,450.111,1639.707,450.11z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013151175171074149210000004867600165976723362_",
    gradientUnits: "userSpaceOnUse",
    x1: 1239.1337,
    y1: 483.4559,
    x2: 1310.9923,
    y2: 400.0487
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000013151175171074149210000004867600165976723362_)"
    },
    cx: 1312.444,
    cy: 398.364,
    r: 53.573
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153691706332791260120000004336810193248762537_",
    gradientUnits: "userSpaceOnUse",
    x1: 1351.597,
    y1: 339.2145,
    x2: 1139.1094,
    y2: 660.2228
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000153691706332791260120000004336810193248762537_)"
    },
    cx: 1312.444,
    cy: 398.364,
    r: 51.792
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.68,
      fill: "#FFFFFF"
    },
    d: "M1269.735,379.025c-0.329,0-0.664-0.074-0.978-0.234 c-1.073-0.541-1.503-1.849-0.961-2.922c8.559-16.957,25.667-27.49,44.649-27.49c3.031,0,6.063,0.273,9.015,0.81 c1.182,0.216,1.966,1.348,1.751,2.53c-0.215,1.183-1.345,1.959-2.53,1.751c-2.695-0.492-5.466-0.74-8.236-0.74 c-17.33,0-32.95,9.618-40.765,25.1C1271.297,378.589,1270.531,379.025,1269.735,379.025z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2601 -0.9656 0.9656 0.2601 586.1863 1563.9563)",
    style: {
      opacity: 0.68,
      fill: "#FFFFFF"
    },
    cx: 1313.572,
    cy: 399.492,
    rx: 43.835,
    ry: 43.835
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134958295513125061010000012568709617408763293_",
    gradientUnits: "userSpaceOnUse",
    x1: 1345.2583,
    y1: 348.4125,
    x2: 1232.1133,
    y2: 538.3644
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134958295513125061010000012568709617408763293_)"
    },
    d: "M1309.271,432.08v-4.769 c-4.972-0.199-9.889-1.372-13.382-2.901c-1.247-0.546-1.883-1.946-1.525-3.259l1.212-4.442c0.444-1.63,2.217-2.472,3.774-1.82 c3.465,1.453,7.742,2.602,12.355,2.602c4.789,0,8.359-1.623,8.359-4.951c0-3.003-2.759-4.788-9.415-6.573 c-9.496-2.597-16.314-6.737-16.314-15.096c0-7.548,5.519-13.311,15.096-14.853v-4.77c0-1.535,1.244-2.779,2.779-2.779h2.802 c1.535,0,2.779,1.244,2.779,2.779v4.282c4.6,0.184,7.949,0.971,10.607,1.905c1.362,0.478,2.106,1.945,1.728,3.338l-1.114,4.108 c-0.43,1.584-2.123,2.452-3.658,1.871c-2.447-0.925-5.906-1.889-10.403-1.889c-5.682,0-7.304,2.354-7.304,4.464 c0,2.597,3.408,4.383,10.794,6.656c10.551,3.165,14.934,7.548,14.934,15.421c0,7.223-5.357,13.716-15.745,15.34v5.337 c0,1.535-1.244,2.779-2.779,2.779h-2.802C1310.515,434.859,1309.271,433.615,1309.271,432.08z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065073822082324440340000010388921008442776243_",
    gradientUnits: "userSpaceOnUse",
    x1: 1337.3209,
    y1: 482.9627,
    x2: 1462.4142,
    y2: 337.7654
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000065073822082324440340000010388921008442776243_)"
    },
    cx: 1464.941,
    cy: 334.832,
    r: 93.262
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095303030865303858120000014159979405389307558_",
    gradientUnits: "userSpaceOnUse",
    x1: 1533.1001,
    y1: 231.8635,
    x2: 1163.1958,
    y2: 790.6835
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000095303030865303858120000014159979405389307558_)"
    },
    cx: 1464.941,
    cy: 334.832,
    r: 90.161
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.68,
      fill: "#FFFFFF"
    },
    d: "M1390.594,299.555c-0.329,0-0.664-0.074-0.978-0.234 c-1.073-0.541-1.503-1.849-0.961-2.922c14.624-28.973,43.855-46.971,76.286-46.971c5.177,0,10.36,0.466,15.406,1.386 c1.182,0.216,1.966,1.349,1.751,2.53c-0.215,1.183-1.35,1.959-2.53,1.751c-4.79-0.873-9.71-1.316-14.626-1.316 c-30.78,0-58.523,17.082-72.403,44.581C1392.155,299.118,1391.389,299.555,1390.594,299.555z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.68,
      fill: "#FFFFFF"
    },
    cx: 1466.906,
    cy: 336.797,
    r: 76.31
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021105809939720952710000011063270409710893481_",
    gradientUnits: "userSpaceOnUse",
    x1: 1522.0654,
    y1: 247.8754,
    x2: 1325.099,
    y2: 578.5494
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021105809939720952710000011063270409710893481_)"
    },
    d: "M1459.417,393.527v-8.302 c-8.655-0.347-17.215-2.389-23.295-5.051c-2.171-0.95-3.278-3.387-2.654-5.673l2.109-7.733 c0.774-2.837,3.859-4.304,6.571-3.167c6.031,2.528,13.478,4.529,21.508,4.529c8.336,0,14.553-2.826,14.553-8.619 c0-5.227-4.804-8.335-16.39-11.443c-16.53-4.521-28.399-11.727-28.399-26.28c0-13.14,9.608-23.172,26.28-25.856v-8.303 c0-2.672,2.166-4.837,4.837-4.837h4.878c2.672,0,4.837,2.166,4.837,4.837v7.454c8.008,0.321,13.838,1.69,18.464,3.316 c2.37,0.833,3.666,3.386,3.008,5.811l-1.94,7.152c-0.748,2.758-3.695,4.268-6.368,3.258 c-4.259-1.611-10.282-3.288-18.109-3.288c-9.89,0-12.715,4.097-12.715,7.771c0,4.521,5.934,7.629,18.791,11.586 c18.368,5.51,25.997,13.139,25.997,26.845c0,12.575-9.325,23.878-27.41,26.704v9.291c0,2.672-2.166,4.837-4.837,4.837h-4.878 C1461.583,398.364,1459.417,396.198,1459.417,393.527z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010274095134819308580000003772665345690264455_",
    gradientUnits: "userSpaceOnUse",
    x1: 1397.9406,
    y1: 695.5617,
    x2: 1526.66,
    y2: 546.1553
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000010274095134819308580000003772665345690264455_)"
    },
    cx: 1529.26,
    cy: 543.137,
    r: 95.965
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142165458635676731490000001723760842546492312_",
    gradientUnits: "userSpaceOnUse",
    x1: 1599.3949,
    y1: 437.1837,
    x2: 1218.7681,
    y2: 1012.2023
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000142165458635676731490000001723760842546492312_)"
    },
    cx: 1529.26,
    cy: 543.137,
    r: 92.774
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.68,
      fill: "#FFFFFF"
    },
    d: "M1452.757,506.774c-0.329,0-0.664-0.074-0.978-0.234 c-1.073-0.541-1.503-1.849-0.961-2.922c15.037-29.791,45.094-48.297,78.442-48.297c5.319,0,10.648,0.479,15.84,1.424 c1.182,0.216,1.965,1.348,1.751,2.53c-0.215,1.181-1.343,1.967-2.53,1.751c-4.935-0.899-10.002-1.354-15.061-1.354 c-31.696,0-60.265,17.591-74.558,45.907C1454.319,506.338,1453.553,506.774,1452.757,506.774z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2225 -0.9749 0.9749 0.2225 659.1378 1916.7954)",
    style: {
      opacity: 0.68,
      fill: "#FFFFFF"
    },
    cx: 1531.281,
    cy: 545.159,
    rx: 78.522,
    ry: 78.522
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084491911577323733220000006072490883297879428_",
    gradientUnits: "userSpaceOnUse",
    x1: 1588.0404,
    y1: 453.6598,
    x2: 1385.3644,
    y2: 793.9193
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000084491911577323733220000006072490883297879428_)"
    },
    d: "M1523.576,603.533v-8.543 c-8.906-0.357-17.714-2.458-23.97-5.197c-2.234-0.978-3.373-3.485-2.731-5.838l2.17-7.957c0.796-2.919,3.971-4.429,6.761-3.259 c6.206,2.602,13.869,4.66,22.132,4.66c8.578,0,14.974-2.908,14.974-8.869c0-5.379-4.943-8.577-16.864-11.775 c-17.01-4.652-29.222-12.067-29.222-27.042c0-13.521,9.887-23.843,27.042-26.605v-8.544c0-2.749,2.229-4.978,4.978-4.978h5.019 c2.749,0,4.978,2.229,4.978,4.978v7.671c8.241,0.33,14.239,1.739,19,3.412c2.439,0.857,3.772,3.484,3.095,5.979l-1.996,7.359 c-0.77,2.838-3.802,4.392-6.553,3.352c-4.383-1.658-10.58-3.383-18.634-3.383c-10.177,0-13.084,4.216-13.084,7.996 c0,4.652,6.106,7.85,19.336,11.922c18.9,5.67,26.75,13.521,26.75,27.623c0,12.939-9.595,24.57-28.204,27.478v9.56 c0,2.749-2.229,4.977-4.978,4.977h-5.02C1525.804,608.511,1523.576,606.282,1523.576,603.533z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147902124621929934950000000968431942276962468_",
    gradientUnits: "userSpaceOnUse",
    x1: 1556.1537,
    y1: 524.0942,
    x2: 1650.4655,
    y2: 414.6252
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000147902124621929934950000000968431942276962468_)"
    },
    cx: 1652.37,
    cy: 412.414,
    r: 70.313
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092420662850261562220000005779607031296484278_",
    gradientUnits: "userSpaceOnUse",
    x1: 1703.7577,
    y1: 334.7827,
    x2: 1424.8754,
    y2: 756.0944
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000092420662850261562220000005779607031296484278_)"
    },
    cx: 1652.37,
    cy: 412.414,
    r: 67.975
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.68,
      fill: "#FFFFFF"
    },
    d: "M1596.317,386.352c-0.329,0-0.664-0.074-0.978-0.234 c-1.073-0.541-1.503-1.849-0.961-2.922c11.118-22.025,33.339-35.707,57.993-35.707c3.932,0,7.873,0.355,11.71,1.054 c1.182,0.216,1.966,1.348,1.751,2.53c-0.215,1.183-1.346,1.958-2.53,1.75c-3.581-0.653-7.258-0.984-10.93-0.984 c-23.002,0-43.735,12.766-54.109,33.316C1597.879,385.916,1597.113,386.352,1596.317,386.352z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.921 -0.3895 0.3895 0.921 -30.6059 676.8354)",
    style: {
      opacity: 0.68,
      fill: "#FFFFFF"
    },
    cx: 1653.851,
    cy: 413.895,
    rx: 57.532,
    ry: 57.532
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178907475898258187490000000762509977017365399_",
    gradientUnits: "userSpaceOnUse",
    x1: 1695.4385,
    y1: 346.8544,
    x2: 1546.9392,
    y2: 596.1601
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178907475898258187490000000762509977017365399_)"
    },
    d: "M1648.206,456.666v-6.259 c-6.525-0.261-12.979-1.801-17.563-3.808c-1.637-0.717-2.471-2.554-2.001-4.277l1.59-5.83c0.583-2.139,2.91-3.245,4.954-2.388 c4.547,1.906,10.162,3.414,16.216,3.414c6.284,0,10.971-2.131,10.971-6.498c0-3.941-3.621-6.284-12.356-8.628 c-12.463-3.409-21.411-8.842-21.411-19.813c0-9.907,7.244-17.47,19.813-19.493v-6.26c0-2.014,1.633-3.647,3.647-3.647h3.677 c2.014,0,3.647,1.633,3.647,3.647v5.62c6.038,0.242,10.433,1.274,13.921,2.5c1.787,0.628,2.763,2.553,2.268,4.381l-1.462,5.392 c-0.564,2.079-2.786,3.218-4.801,2.456c-3.212-1.214-7.752-2.479-13.653-2.479c-7.457,0-9.587,3.089-9.587,5.859 c0,3.408,4.474,5.752,14.167,8.735c13.848,4.154,19.6,9.906,19.6,20.239c0,9.48-7.03,18.002-20.665,20.133v7.005 c0,2.014-1.633,3.647-3.647,3.647h-3.678C1649.839,460.313,1648.206,458.68,1648.206,456.666z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M750.798,262.524c0,0-0.729,0.311-1.479,1.071c-0.695,0.763-1.332,2.027-2.258,3.045 c-1.735,1.879-3.181,4.003-3.181,4.003l-0.021,0.025c-0.561,0.658-0.906,1.318-0.215,1.95c0.692,0.631,1.525,0.457,2.112-0.179 c0,0,1.656-1.984,3.414-3.882c0.433-0.479,0.816-1.002,1.221-1.451c0.445-0.488,0.62-0.744,0.887-1.07 c0.241-0.295,0.4-0.555,0.635-0.765c0.199-0.199,0.307-0.317,0.307-0.317l0.5-0.503c0.601-0.598,0.785-1.409,0.13-2.051 c-0.655-0.642-1.497-0.528-2.044,0.115L750.798,262.524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M735.915,277.217l-7.53,7.025c-0.629,0.586-0.615,1.603,0.03,2.272 c0.645,0.669,1.676,0.736,2.304,0.15l7.54-7.015c0.631-0.588,0.62-1.609-0.027-2.281c-0.647-0.672-1.683-0.74-2.315-0.152 L735.915,277.217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M721.153,291.848l-8.362,5.886c-0.672,0.527-0.865,1.284-0.276,1.991 c0.589,0.707,1.548,0.731,2.22,0.204l8.089-6.425c0.675-0.529,0.979-1.075,0.389-1.786c-0.59-0.711-1.27-0.012-2.057,0.13 L721.153,291.848z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M705.153,305.326l-9.141,4.552c-0.714,0.462-1.094,0.904-0.569,1.647 c0.525,0.744,1.416,0.705,2.13,0.243l8.638-5.746c0.718-0.463,1.298-0.44,0.772-1.187c-0.526-0.747-1.061,0.352-1.827,0.489 L705.153,305.326z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M685.604,310.887l-8.714,6.25c-0.756,0.385-0.727,2.089-0.277,2.868 c0.45,0.779,1.565,1.479,2.321,1.094l9.342-4.527c0.759-0.385,0.491-2.758,0.039-3.541c-0.451-0.782-1.973-2.276-2.709-2.144 L685.604,310.887z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M668.119,324.257l-9.851,2.915c-0.794,0.294-1.163,0.825-0.802,1.635 c0.361,0.81,1.289,1.047,2.083,0.753l9.817-3.722c0.798-0.294,1.184-0.511,0.822-1.324c-0.362-0.814-1.373-0.382-2.068-0.257 L668.119,324.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M646.978,328.059l-9.623,3.027c-0.827,0.188-0.948,1.355-0.692,2.189 c0.256,0.834,1.304,1.527,2.131,1.339l10.396-2.254c0.831-0.188,0.655-1.653,0.399-2.49c-0.256-0.838-0.139-0.21-2.608-1.811 L646.978,328.059z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M627.904,333.535l-10.729,0.792c-0.847,0.073-1.466,0.741-1.324,1.586 c0.141,0.845,0.921,1.432,1.768,1.359l10.627-0.952c0.851-0.073,1.512-0.676,1.372-1.525c-0.141-0.849-0.906-1.405-1.709-1.261 L627.904,333.535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M606.862,335.269l-10.9,0.36c-0.845,0.041-1.54,0.672-1.432,1.512 c0.107,0.84,0.831,1.447,1.676,1.406l10.683-0.535c0.849-0.04,1.632-0.601,1.524-1.445c-0.107-0.844-1.172-1.742-1.549-1.3 L606.862,335.269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M585.595,337.056l-10.997-0.811c-0.843-0.012-1.601,0.315-1.547,1.149 c0.055,0.834,0.724,1.349,1.567,1.361l10.731,0.057c0.847,0.012,1.711-0.018,1.657-0.856c-0.054-0.838-0.744-1.019-1.409-0.9 L585.595,337.056z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M563.717,334.856l-10.787-1.079c-0.837-0.091-1.538,0.536-1.565,1.358 c-0.027,0.823,0.633,1.581,1.47,1.673l10.787,1.169c0.841,0.093,1.545-0.567,1.573-1.393c0.029-0.826-0.682-1.871-1.472-1.729 L563.717,334.856z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M542.511,332.536c0,0-2.709-0.941-5.367-1.604c-2.556-0.796-5.138-1.731-5.138-1.731 l-0.117-0.102c-0.808-0.252-1.625,0.143-1.817,0.923c-0.192,0.781,0.303,1.6,1.111,1.851c0,0,2.693,0.831,5.387,1.672 c2.658,0.666,5.315,1.328,5.315,1.328c0.822,0.208,1.657,0.004,1.803-0.793c0.146-0.798-0.425-1.679-1.172-1.545 L542.511,332.536z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M521.477,324.959c0,0-0.238-0.479-1.13-1.019c-0.44-0.272-0.812-0.639-1.292-0.998 c-0.504-0.352-0.952-0.757-1.49-1.133c-1.026-0.838-2.064-1.647-2.753-2.36c-0.723-0.682-1.182-1.144-1.182-1.144l-0.088-0.098 c-0.618-0.583-1.554-0.599-2.098-0.033c-0.544,0.566-0.484,1.494,0.133,2.078c0,0,0.532,0.503,1.327,1.258 c0.77,0.789,1.938,1.657,3.071,2.577c0.604,0.422,1.209,0.845,1.775,1.24c0.572,0.418,1.086,0.703,1.533,0.98 c0.891,0.542,1.486,0.903,1.486,0.903c0.728,0.443,1.279,0.366,1.672-0.321c0.393-0.687-0.831-1.187-0.964-1.926 L521.477,324.959z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M506.612,310.525c0,0,0.447-1.05,0.106-2.014c-0.195-0.494,0-1.233-0.132-1.792 c-0.073-0.283,0.021-0.677-0.056-0.974c-0.029-0.098-0.015-0.461-0.011-0.386l-0.023-0.524 c-0.036-0.324-0.082-0.698-0.094-0.986c0.001-0.267,0.012-0.537,0.012-0.791c-0.019-0.504,0.098-1.056,0.123-1.488 c0.159-0.879,0.292-1.465,0.292-1.465l0.017-0.072c0.172-0.773-0.336-1.587-1.135-1.818c-0.793-0.229-1.575,0.204-1.753,0.968 c0,0-0.161,0.691-0.348,1.747c-0.041,0.556-0.163,1.14-0.149,1.885c0.005,0.368,0.012,0.749,0.018,1.136 c0.021,0.367,0.08,0.671,0.118,1.013l0.065,0.498c0.079,0.402,0.099,0.415,0.151,0.64c0.09,0.349,0.178,0.693,0.264,1.025 c0.166,0.675,0.336,1.285,0.519,1.746c0.34,0.965,0.566,1.608,0.566,1.608c0.276,0.782,0.451,1.652,1.224,1.44 c0.773-0.212,0.339-0.762,0.225-1.393L506.612,310.525z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M511.933,292.079c0,0,1.403-2.18,3.117-4.095c1.85-1.619,3.544-3.371,3.544-3.371l0.036-0.166 c0.582-0.509,0.471-1.352-0.092-1.967c-0.563-0.616-0.758-1.602-2.178-0.108l-0.01-0.009c0,0-1.941,1.67-3.964,3.446 c-1.718,1.915-3.394,3.776-3.394,3.776c-0.518,0.578-0.099,1.737,0.529,2.296c0.627,0.558,1.902,0.795,2.406,0.204 L511.933,292.079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M526.663,278.13c0,0,0.767,0.392,1.689,0.052c0.453-0.145,1.092-0.114,1.634-0.216 c0.55-0.137,1.174-0.128,1.761-0.274c0.583-0.159,1.232-0.084,1.797-0.173c0.572-0.087,1.114-0.093,1.563-0.039 c0.903,0.035,1.51,0.077,1.51,0.077l0.275,0.02c0.799,0.031,1.422-0.58,1.39-1.369c-0.031-0.785-0.698-1.444-1.492-1.481 c0,0-0.746-0.033-1.866-0.085c-0.57-0.055-1.201-0.006-1.865,0.089c-0.665,0.098-1.395,0.114-2.087,0.295 c-0.694,0.174-1.388,0.349-2.039,0.512c-0.677,0.15-1.142,0.392-1.626,0.548c-0.922,0.339-1.537,0.564-1.537,0.564 c-0.736,0.267-1.219,0.474-0.889,1.224c0.329,0.751,1.045,0.388,1.778,0.256L526.663,278.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M542.492,282.634c0,0,1.957,0.116,2.66,0.886c0.176,0.193,1.11,0.203,1.311,0.423 c0.205,0.221,0.687,0.351,0.86,0.589c0.322,0.475,0.852,0.931,1.195,1.437c0.299,0.572,0.69,1.118,0.97,1.654 c0.305,0.523,0.736,0.985,0.92,1.435c0.361,0.903,0.825,1.433,0.825,1.433l0.064,0.125c0.303,0.748,0.946,1.227,1.682,0.988 c0.737-0.238,0.995-1.002,0.696-1.75c0,0-0.313-0.652-0.711-1.653c-0.203-0.499-0.433-1.082-0.775-1.683 c-0.317-0.607-0.668-1.251-1.007-1.899c-0.413-0.642-0.872-1.276-1.282-1.871c-0.408-0.635-0.824-1.072-1.176-1.449 c-0.702-0.771-1.172-1.284-1.172-1.284c-0.555-0.61-2.96-0.3-3.535,0.202c-0.576,0.502-1.653,1.691-1.524,2.41L542.492,282.634z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M551.928,300.984c0,0,0.706,2.569,0.885,5.233c-0.016,2.579,0.231,5.11,0.231,5.11l0.131,0.076 c-0.005,0.776,0.697,1.447,1.486,1.513c0.789,0.065,1.465-0.516,1.47-1.293c0,0,0.034-2.733,0.051-5.463 c-0.176-2.664-0.343-5.329-0.343-5.329c-0.052-0.783-1.258-1.332-2.049-1.342c-0.791-0.01-2,0.726-1.862,1.493L551.928,300.984z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M551.251,320.74c0,0-0.076,2.953-0.616,5.513c-0.673,2.459-1.115,5.115-1.115,5.115l0.096,0.169 c-0.199,0.729,0.31,1.576,1.066,1.831c0.756,0.255,1.56-0.104,1.76-0.834c0,0,0.719-2.557,1.424-5.127 c0.543-2.56,1.092-5.113,1.092-5.113c0.158-0.746-0.797-1.913-1.567-2.128c-0.77-0.215-1.511,0.46-2.139,0.573L551.251,320.74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M546.543,339.99l-4.531,9.946c-0.316,0.673-0.063,1.808,0.645,2.174 c0.708,0.366,1.508,0.262,1.824-0.411l4.397-9.281c0.319-0.675,0.122-2.069-0.588-2.437c-0.711-0.369-2.356-1.926-1.743,0.009 L546.543,339.99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M536.854,360.137l-5.637,8.22c-0.402,0.614-0.192,1.274,0.463,1.72 c0.655,0.447,1.516,0.211,1.917-0.403l5.658-8.661c0.405-0.616,0.191-1.105-0.466-1.554c-0.657-0.449-1.247,0.554-1.932,0.677 L536.854,360.137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M525.204,376.188c0,0-0.393,0.509-0.983,1.272c-0.598,0.749-1.395,1.749-2.193,2.747 c-1.611,2.006-3.222,4.012-3.222,4.012c-0.455,0.567-0.328,1.427,0.282,1.922c0.611,0.495,1.474,0.438,1.929-0.128 c0,0,1.614-2.004,3.227-4.007c0.809-1.011,1.618-2.022,2.224-2.78c0.591-0.763,0.985-1.271,0.985-1.271 c0.447-0.577,0.306-1.44-0.315-1.928c-0.621-0.488-1.487-0.416-1.934,0.161L525.204,376.188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M512.21,392.022l-6.872,7.66c-0.481,0.536-0.399,1.39,0.183,1.908 c0.582,0.518,1.443,0.505,1.924-0.031l6.882-7.652c0.484-0.538,0.403-1.396-0.181-1.917c-0.584-0.521-1.449-0.508-1.933,0.029 L512.21,392.022z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M498.282,407.07l-7.355,7.206c-0.51,0.499-0.48,1.345,0.067,1.889 c0.547,0.544,1.403,0.582,1.913,0.082l7.365-7.197c0.513-0.501,0.483-1.351-0.066-1.898c-0.549-0.547-1.41-0.585-1.923-0.084 L498.282,407.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M483.382,421.163l-7.874,6.657c-0.541,0.457-0.569,1.291-0.062,1.862 c0.507,0.572,1.355,0.665,1.896,0.208l7.882-6.647c0.544-0.458,0.573-1.296,0.065-1.871c-0.508-0.575-1.361-0.669-1.905-0.211 L483.382,421.163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M467.214,433.903l-8.318,6.079c-0.574,0.407-0.611,1.271-0.153,1.871 c0.458,0.6,1.322,0.781,1.896,0.375l8.453-5.96c0.577-0.408,0.566-1.318,0.107-1.921c-0.46-0.603-1.539-0.966-1.983-0.445 L467.214,433.903z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M450.488,445.954l-8.388,6.037c-0.565,0.407-0.652,1.216-0.195,1.808 c0.458,0.592,1.286,0.743,1.85,0.336l8.396-6.026c0.568-0.408,0.657-1.221,0.198-1.816c-0.459-0.595-1.292-0.746-1.861-0.339 L450.488,445.954z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M433.805,458.223l-8.12,6.371c-0.542,0.425-0.597,1.232-0.122,1.802 c0.475,0.57,1.297,0.689,1.839,0.263l8.128-6.361c0.545-0.426,0.601-1.237,0.125-1.81c-0.476-0.573-1.304-0.692-1.849-0.266 L433.805,458.223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M417.67,471.166l-7.828,6.709c-0.517,0.443-0.538,1.247-0.048,1.793 c0.491,0.547,1.307,0.633,1.825,0.189l7.836-6.7c0.52-0.445,0.543-1.252,0.05-1.802c-0.493-0.551-1.314-0.636-1.835-0.191 L417.67,471.166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M402.132,484.789l-7.511,7.049c-0.491,0.461-0.479,1.259,0.028,1.782 c0.508,0.523,1.316,0.574,1.808,0.113l7.52-7.04c0.494-0.463,0.482-1.265-0.026-1.791c-0.509-0.526-1.323-0.578-1.817-0.114 L402.132,484.789z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M387.241,499.094l-7.168,7.388c-0.464,0.479-0.417,1.27,0.106,1.768 c0.523,0.498,1.322,0.514,1.787,0.035l7.178-7.38c0.467-0.481,0.421-1.276-0.104-1.777c-0.525-0.501-1.329-0.517-1.797-0.036 L387.241,499.094z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M373.049,514.079l-6.799,7.726c-0.436,0.496-0.354,1.279,0.184,1.75 c0.538,0.471,1.326,0.452,1.763-0.044l6.809-7.717c0.439-0.497,0.357-1.285-0.182-1.759c-0.54-0.474-1.334-0.455-1.773,0.043 L373.049,514.079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M359.61,529.74l-6.402,8.058c-0.407,0.512-0.289,1.286,0.263,1.729 c0.552,0.443,1.328,0.388,1.735-0.124l6.413-8.05c0.409-0.514,0.292-1.292-0.262-1.738c-0.555-0.446-1.336-0.391-1.745,0.123 L359.61,529.74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M346.98,546.065l-5.978,8.384c-0.376,0.527-0.223,1.29,0.342,1.704 c0.565,0.414,1.327,0.323,1.703-0.204l5.988-8.376c0.378-0.529,0.225-1.296-0.342-1.712c-0.568-0.417-1.334-0.325-1.712,0.204 L346.98,546.065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M335.216,563.04l-5.524,8.701c-0.344,0.541-0.155,1.291,0.423,1.674 c0.577,0.383,1.322,0.256,1.666-0.286l5.535-8.693c0.346-0.544,0.157-1.297-0.423-1.683c-0.579-0.385-1.33-0.257-1.676,0.286 L335.216,563.04z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M324.376,580.646l-5.043,9.014c-0.31,0.555-0.086,1.289,0.502,1.64 c0.588,0.351,1.316,0.187,1.626-0.368l5.055-9.007c0.313-0.557,0.087-1.295-0.503-1.649c-0.591-0.354-1.323-0.188-1.635,0.369 L324.376,580.646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M314.516,598.876l-4.524,9.304c-0.276,0.567-0.015,1.283,0.583,1.601 c0.597,0.317,1.304,0.117,1.58-0.45l4.535-9.298c0.278-0.569,0.016-1.29-0.583-1.61c-0.6-0.32-1.312-0.118-1.589,0.452 L314.516,598.876z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M305.714,617.681l-3.969,9.578c-0.239,0.577,0.057,1.274,0.663,1.557 c0.605,0.282,1.29,0.044,1.529-0.533l3.98-9.572c0.241-0.58-0.056-1.281-0.664-1.565c-0.608-0.285-1.297-0.045-1.539,0.535 L305.714,617.681z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M298.047,637.024c0,0-0.854,2.455-1.708,4.91c-0.423,1.211-0.865,2.476-1.159,3.402 c-0.304,0.927-0.506,1.545-0.506,1.545c-0.193,0.59,0.148,1.261,0.762,1.498c0.614,0.238,1.268-0.046,1.462-0.636 c0,0,0.203-0.618,0.508-1.545c0.298-0.934,0.715-2.122,1.151-3.364c0.857-2.453,1.714-4.907,1.714-4.907 c0.206-0.589-0.125-1.268-0.74-1.518c-0.614-0.25-1.278,0.025-1.484,0.614L298.047,637.024z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M291.619,656.897l-2.711,10.075c-0.16,0.595,0.21,1.243,0.827,1.448 c0.616,0.205,1.246-0.109,1.406-0.704l2.724-10.071c0.162-0.598-0.21-1.25-0.829-1.457c-0.62-0.207-1.253,0.11-1.415,0.707 L291.619,656.897z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M286.522,677.227l-2.009,10.284c-0.117,0.6,0.29,1.22,0.908,1.383 c0.619,0.163,1.216-0.19,1.333-0.79l2.022-10.281c0.119-0.603-0.29-1.226-0.912-1.391c-0.622-0.165-1.223,0.191-1.342,0.794 L286.522,677.227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M282.866,697.967l-1.242,10.459c-0.072,0.604,0.372,1.189,0.991,1.308 c0.619,0.119,1.179-0.274,1.25-0.878l1.254-10.456c0.073-0.607-0.372-1.196-0.995-1.316c-0.622-0.12-1.186,0.275-1.259,0.882 L282.866,697.967z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M280.784,719.039l-0.409,10.586c-0.023,0.604,0.457,1.152,1.073,1.222 c0.615,0.07,1.134-0.361,1.157-0.966l0.421-10.585c0.024-0.608-0.458-1.159-1.077-1.23c-0.619-0.071-1.141,0.363-1.165,0.971 V719.039z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M280.407,740.345l0.489,10.652c0.028,0.601,0.543,1.105,1.152,1.125 c0.609,0.02,1.08-0.45,1.052-1.052l-0.476-10.652c-0.027-0.605-0.545-1.112-1.158-1.132c-0.612-0.021-1.086,0.453-1.059,1.058 V740.345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M281.867,761.751l1.452,10.641c0.081,0.594,0.631,1.048,1.228,1.014 c0.597-0.034,1.015-0.541,0.934-1.135l-1.44-10.642c-0.081-0.597-0.633-1.055-1.233-1.021c-0.6,0.033-1.021,0.544-0.941,1.142 L281.867,761.751z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M285.297,783.092l2.016,8.702c0.135,0.582,0.715,0.982,1.295,0.895 c0.581-0.088,0.942-0.63,0.808-1.212l-2.006-8.703c-0.135-0.585-0.717-0.988-1.301-0.9c-0.584,0.088-0.947,0.633-0.812,1.218 L285.297,783.092z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "761.194,215.366 761.9,254.3 787.965,237.083  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M935.87,189.844l-103.473,94.134c-1.981,1.802-4.61,2.721-7.283,2.544 c-2.672-0.177-5.158-1.434-6.884-3.481l-90.598-107.449c-1.037-1.23-1.225-2.967-0.474-4.39c0.751-1.423,2.29-2.249,3.891-2.087 L935.87,189.844z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "761.207,215.37 935.87,189.844 775.774,232.756 775.51,243.561  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "784.489,242.998 761.9,254.3 775.774,232.756  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickbookSupport);
export default __webpack_public_path__ + "static/media/quickbook_support.37271045d5342549a14dd0eab08eab08.svg";
export { ForwardRef as ReactComponent };